import React, { useState, useEffect } from "react";
import {
  Document,
  Page,
  Text,
  View,
  Image,
  Link,
  PDFDownloadLink,
  Font,
  StyleSheet
} from "@react-pdf/renderer";
import logo from "../../mi_logo_report.png";
// import Electrical_Cover_New from "../../Electrical_Safety_Report_Cover.png";
// import Electrical_Cover_New from "../../Electrical PNG.png"; 
// import Electrical_Cover_New from "../../ElectricalPortrait.png";
import Electrical_Cover_New from "../../Electrical2026_PNG.png";
// import HSE_Cover_New from "../../HSE_Report_Cover.png";
// import HSE_Cover_New from "../../HSE PNG.png";
// import HSE_Cover_New from "../../HSEPortrait.png";
import HSE_Cover_New from "../../HSE2026_PNG.png";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import axios from "../../APIs/axios";
import { config } from "../../config";
import { toast } from 'react-toastify';
import HTMLReactParser from 'html-react-parser'
import parse from 'html-react-parser';
import { color, fontStyle, fontWeight, textAlign } from "@mui/system";

Font.register({
  family: 'Montserrat',
  fonts: [
    { src: '/fonts/Montserrat-Regular.ttf', fontWeight: 400 },
    { src: '/fonts/Montserrat-Italic.ttf', fontWeight: 400, fontStyle: 'italic' },
    { src: '/fonts/Montserrat-Bold.ttf', fontWeight: 700 },
    { src: '/fonts/Montserrat-BoldItalic.ttf', fontWeight: 700, fontStyle: 'italic' },
  ]
});

const supportedFonts = ["Montserrat", "Roboto", "Lora", "Courier Prime", "Lato", "Merriweather"];

const fallbackFontMap = {

  "arial": "Montserrat",
  "times new roman": "Lora",
  "georgia": "Lora",
  "verdana": "Montserrat",
  "courier new": "Courier",

  // Unsupported fonts fallback
  "lucida sans unicode": "Montserrat",
  "tahoma": "Montserrat",
  "trebuchet ms": "Montserrat",
  "helvetica": "Montserrat",
  "impact": "Montserrat",
  "merriweather": "Montserrat"
};
const splitIntoChunks = (text, chunkSize = 300) => {
  const chunks = [];
  for (let i = 0; i < text.length; i += chunkSize) {
    chunks.push(text.slice(i, i + chunkSize));
  }
  return chunks;
};

const PdfSafeText = ({ text, style }) => {
  const chunks = splitIntoChunks(text || "", 300);

  return (
    <View style={{ flexDirection: "column" }}>
      {chunks.map((chunk, i) => (
        <Text key={i} style={style}>
          {chunk}
        </Text>
      ))}
    </View>
  );
};


const sanitizeFontFamily = (font) => {
  if (!font) return "Montserrat";
  const cleanedFont = font.replace(/['"]/g, "").trim();

  if (supportedFonts.includes(cleanedFont)) {
    return cleanedFont;
  }

  return fallbackFontMap[cleanedFont] || "Montserrat";
};

// Normalize a field value to "N/A" when it is missing. Covers real null /
// undefined / empty strings AND the literal strings "null" / "undefined",
// which some observation records store as text (e.g. equipment, status).
const naValue = (value) => {
  if (value === null || value === undefined) return "N/A";
  const s = String(value).trim();
  if (s === "" || s.toLowerCase() === "null" || s.toLowerCase() === "undefined") {
    return "N/A";
  }
  return value;
};

const renderTextWithUnicodeBullets = (text) => {
  if (!text) return <Text style={{ fontSize: 10 }}>N/A</Text>;

  // Check if text contains HTML tags
  const hasHtmlTags = /<[a-z][\s\S]*>/i.test(text);

  if (hasHtmlTags) {
    // If HTML, use renderFormattedText to preserve HTML formatting
    return renderFormattedText(text);
  }

  // If plain text, split by newlines and render each line separately to preserve spacing
  // Don't use non-breaking spaces to allow proper text wrapping
  const lines = text.split('\n');
  return (
    <View style={{ flexDirection: 'column' }}>
      {lines.map((line, index) => {
        // If line is empty, add more margin to preserve blank line spacing
        const isEmpty = line.trim() === '';
        return (
          <Text
            key={index}
            style={{
              fontSize: 9,
              marginBottom: isEmpty ? 8 : 4,
              lineHeight: 1.5,
              fontFamily: 'Montserrat',
            }}
          >
            {line}
          </Text>
        );
      })}
    </View>
  );
};

const renderWrappedText = (text, maxCharsPerLine = 25) => {
  if (!text) return <Text style={{ fontSize: 9 }}>N/A</Text>;

  const lines = text.split('\n');
  return (
    <View style={{ flexDirection: 'column' }}>
      {lines.map((line, lineIndex) => {
        const chunks = [];
        for (let i = 0; i < line.length; i += maxCharsPerLine) {
          chunks.push(line.slice(i, i + maxCharsPerLine));
        }
        return chunks.map((chunk, chunkIndex) => (
          <Text
            key={`${lineIndex}-${chunkIndex}`}
            style={{
              fontSize: 9,
              marginBottom: 2,
              lineHeight: 1.3,
              fontFamily: 'Montserrat',
            }}
          >
            {chunk}
          </Text>
        ));
      })}
    </View>
  );
};

const renderPlainTextWithLineBreaks = (text) => {
  if (!text) return <Text style={{ fontSize: 10 }}>N/A</Text>;

  // Check if text contains HTML tags
  const hasHtmlTags = /<[a-z][\s\S]*>/i.test(text);

  if (hasHtmlTags) {
    // If HTML, use renderFormattedText to preserve HTML formatting
    return renderFormattedText(text);
  }

  // If plain text, split by newlines and render each line separately to preserve spacing
  // Replace ALL spaces with non-breaking spaces to preserve exact spacing
  const lines = text.split('\n');
  return (
    <View style={{ flexDirection: 'column' }}>
      {lines.map((line, index) => {
        // If line is empty, add more margin to preserve blank line spacing
        const isEmpty = line.trim() === '';
        return (
          <Text
            key={index}
            style={{
              fontSize: 10,
              marginBottom: isEmpty ? 8 : 2
            }}
          >
            {line.replace(/ /g, '\u00A0')}
          </Text>
        );
      })}
    </View>
  );
};

const renderTextWithBullets = (text) => {
  if (!text) return <Text style={{ fontSize: 10 }}>N/A</Text>;

  // Check if text contains HTML tags
  const hasHtmlTags = /<[a-z][\s\S]*>/i.test(text);

  if (hasHtmlTags) {
    // If HTML, use renderFormattedText to preserve HTML formatting
    return renderFormattedText(text);
  }

  // Split by newlines and render each line with bullet point
  const lines = text.split('\n').map(line => line.trim()).filter(line => line);
  return (
    <View style={{ flexDirection: 'column' }}>
      {lines.map((line, index) => (
        <Text key={index} style={{ fontSize: 10, marginBottom: 2 }}>
          • {line}
        </Text>
      ))}
    </View>
  );
};

// Unified rich-text rendering: every section that shows saved editor HTML now
// renders through the one faithful renderer (renderFormattedTextSafe), so the
// PDF matches the editor consistently — paragraphs, nested lists, ordered-list
// numbering, bold/italic/underline, <br> line breaks, and fonts. The previous
// implementation is preserved below as renderFormattedTextLegacy (unused).
const renderFormattedText = (html) => renderFormattedTextSafe(html);

// eslint-disable-next-line no-unused-vars
const renderFormattedTextLegacy = (html) => {
  const wrapper = document.createElement("div");
  wrapper.innerHTML = html;

  let listItemCounter = 1;

  const parseNode = (node, key, parentTag = null) => {
    // Skip empty <p> or <li> or <br> nodes
    if (
      node.nodeType === 3 &&
      (node.textContent || "").trim() === ""
    ) {
      return null;
    }

    if (node.nodeType !== 3) {
      const text = (node.textContent || "").trim();
      if (text === "" && ["P", "DIV", "LI"].includes(node.nodeName.toUpperCase())) {
        return null;
      }
    }


    // if (node.nodeType === 3) {
    //   return <Text key={key}>{node.textContent}</Text>;
    // }
    if (node.nodeType === 3) {
      // use PdfSafeText so long inline text is chunked and safe for react-pdf layout
      return <PdfSafeText key={key} text={node.textContent || ""} style={{ fontSize: 12 }} />;
    }


    const tag = node.nodeName.toUpperCase();
    const style = {
      fontFamily: "Montserrat", // Default fallback
    };


    if (node.getAttribute) {
      const styleAttr = node.getAttribute("style") || "";

      const fontSizeMatch = styleAttr.match(/font-size:\s*(\d+)px/);
      if (fontSizeMatch) {
        style.fontSize = parseInt(fontSizeMatch[1], 10);
      }

      const fontFamilyMatch = styleAttr.match(/font-family:\s*([^;]+)/);
      if (fontFamilyMatch) {
        const rawFont = fontFamilyMatch[1].split(",")[0];
        style.fontFamily = sanitizeFontFamily(rawFont);
      }
    }

    // Tag-based formatting
    if (tag === "B" || tag === "STRONG") {
      style.fontWeight = 700;
    }
    if (tag === "I" || tag === "EM") {
      style.fontStyle = "italic";
    }
    if (tag === "U") {
      style.textDecoration = "underline";
    }
    if (tag === "BR") {
      return <Text key={key}>{"\n"}</Text>;
    }


    const children = Array.from(node.childNodes).map((child, i) =>
      parseNode(child, `${key}-${i}`, tag)
    );

    if (tag === "P" && parentTag === "LI") {
      return <Text key={key} style={style}>{children}</Text>;
    }
    if (tag === "P") {
      return (
        <View key={key} style={{ paddingBottom: 4, marginBottom: 4 }}>
          <Text style={{ ...style, lineHeight: 1.5 }}>{children}</Text>
        </View>
      );
    }

    // List handling
    if (tag === "UL" || tag === "OL") {
      listItemCounter = 1;
      return (
        <View key={key} style={{ paddingBottom: 0, marginBottom: 0 }}>
          {children}
        </View>
      );
    }

    if (tag === "LI") {
      const text = node.textContent.trim();

      // ❌ Prevent empty bullets
      if (!text || text === "•") return null;

      const isOrdered = parentTag === "OL";
      const bullet = isOrdered ? `${listItemCounter++}. ` : "• ";

      return (
        <Text
          key={key}
          style={{
            marginLeft: 15,
            marginBottom: 4,
            lineHeight: 1.5,
            ...style
          }}
        >
          {bullet}
          {children}
        </Text>
      );
    }


    return (
      // <Text key={key} style={style}>
      <Text key={key} style={{ ...style, lineHeight: 1.5 }}>
        {children}
      </Text>
    );
  };

  return Array.from(wrapper.childNodes).map((node, i) =>
    parseNode(node, `node-${i}`)
  );
};

const normalizeBullets = (html) => {
  return html
    // convert "• text" into proper <ul><li>
    .replace(/<p>\s*•\s*(.*?)<\/p>/g, "<ul><li>$1</li></ul>")
    // remove empty <p><br></p>
    .replace(/<p><br><\/p>/g, "")
    .replace(/<p>\s*<\/p>/g, "");
};


const renderFormattedTextSafe = (html) => {
  const wrapper = document.createElement("div");
  wrapper.innerHTML = html || "";

  let keySeq = 0;
  const nextKey = (p) => `${p}-${keySeq++}`;

  // Base text style. fontFamily Montserrat matches the rest of the report and is
  // required for <b>/<strong> to render (the bold weight is only registered for
  // Montserrat). The default text font would ignore fontWeight.
  const BASE = { fontFamily: "Montserrat", fontSize: 12, lineHeight: 1.5 };

  // Pull font-size / font-family from an inline style attribute, like the editor.
  const styleFromAttr = (node) => {
    const s = {};
    if (node.getAttribute) {
      const attr = node.getAttribute("style") || "";
      const fs = attr.match(/font-size:\s*(\d+)px/);
      if (fs) s.fontSize = parseInt(fs[1], 10);
      const ff = attr.match(/font-family:\s*([^;]+)/);
      if (ff) s.fontFamily = sanitizeFontFamily(ff[1].split(",")[0]);
    }
    return s;
  };

  // Build a node's inline children: plain text runs (each a single <Text> so
  // react-pdf wraps/hyphenates naturally), <br> line breaks, and inline emphasis
  // (<b>/<strong>, <i>/<em>, <u>). Nested <ul>/<ol> are NOT consumed here — they
  // are handled as separate blocks so they don't get flattened inline. Walking
  // the DOM (not textContent) is what preserves <br> breaks and emphasis.
  const renderInlineNodes = (nodes, inheritStyle) => {
    const out = [];
    nodes.forEach((child) => {
      if (child.nodeType === 3) {
        const t = child.textContent || "";
        if (t) out.push(<Text key={nextKey("t")} style={inheritStyle}>{t}</Text>);
        return;
      }
      if (child.nodeType !== 1) return;
      const tag = child.nodeName.toUpperCase();
      if (tag === "BR") {
        out.push(<Text key={nextKey("br")}>{"\n"}</Text>);
        return;
      }
      if (tag === "UL" || tag === "OL") return; // handled as a block, not inline
      const style = { ...inheritStyle, ...styleFromAttr(child) };
      if (tag === "B" || tag === "STRONG") style.fontWeight = 700;
      if (tag === "I" || tag === "EM") style.fontStyle = "italic";
      if (tag === "U") style.textDecoration = "underline";
      out.push(
        <Text key={nextKey("i")} style={style}>
          {renderInlineNodes(Array.from(child.childNodes), style)}
        </Text>
      );
    });
    return out;
  };

  const blocks = [];

  // Render a <ul>/<ol> at the given nesting depth. Each <li> gets its own line
  // with a marker and an indent that grows with depth; nested lists recurse at
  // depth + 1 so they sit below their parent item (instead of running inline).
  const renderList = (listNode, depth) => {
    const ordered = listNode.nodeName.toUpperCase() === "OL";
    // Honor the editor's numbering: <ol start="N"> / <li value="N">.
    let n = ordered ? parseInt(listNode.getAttribute("start"), 10) || 1 : 1;
    Array.from(listNode.children).forEach((li) => {
      if (li.nodeName.toUpperCase() !== "LI") {
        renderBlock(li);
        return;
      }
      const inlineKids = [];
      const nestedLists = [];
      Array.from(li.childNodes).forEach((c) => {
        const t = c.nodeType === 1 ? c.nodeName.toUpperCase() : "";
        if (t === "UL" || t === "OL") nestedLists.push(c);
        else inlineKids.push(c);
      });
      let marker = "• ";
      if (ordered) {
        const liVal = parseInt(li.getAttribute("value"), 10);
        if (!isNaN(liVal)) n = liVal;
        marker = `${n++}. `;
      }
      if (inlineKids.map((c) => c.textContent || "").join("").trim()) {
        blocks.push(
          <Text
            key={nextKey("li")}
            style={{ ...BASE, marginLeft: 15 + depth * 18, marginBottom: 4 }}
          >
            {marker}
            {renderInlineNodes(inlineKids, { fontFamily: "Montserrat" })}
          </Text>
        );
      }
      nestedLists.forEach((nl) => renderList(nl, depth + 1));
    });
  };

  const renderBlock = (node) => {
    if (node.nodeType === 3) {
      const t = (node.textContent || "").trim();
      if (t) {
        blocks.push(
          <View key={nextKey("tb")} style={{ marginBottom: 4 }}>
            <Text style={BASE}>{t}</Text>
          </View>
        );
      }
      return;
    }
    if (node.nodeType !== 1) return;

    const tag = node.nodeName.toUpperCase();

    if (tag === "UL" || tag === "OL") {
      renderList(node, 0);
      return;
    }

    // ---- Stray top-level <li> (no parent list) ----
    if (tag === "LI") {
      if ((node.textContent || "").trim()) {
        blocks.push(
          <Text
            key={nextKey("li")}
            style={{ ...BASE, marginLeft: 15, marginBottom: 4 }}
          >
            {"• "}
            {renderInlineNodes(Array.from(node.childNodes), { fontFamily: "Montserrat" })}
          </Text>
        );
      }
      return;
    }

    // ---- Containers that wrap block children: recurse ----
    if (tag === "DIV") {
      const hasBlockChild = Array.from(node.childNodes).some(
        (c) =>
          c.nodeType === 1 &&
          ["P", "DIV", "UL", "OL", "LI"].includes(c.nodeName.toUpperCase())
      );
      if (hasBlockChild) {
        Array.from(node.childNodes).forEach(renderBlock);
        return;
      }
    }

    // ---- Paragraphs / plain blocks: render inline content (preserves <br>) ----
    if (tag === "P" || tag === "DIV") {
      if ((node.textContent || "").trim()) {
        blocks.push(
          <View key={nextKey("p")} style={{ marginBottom: 4 }}>
            <Text style={{ ...BASE, ...styleFromAttr(node) }}>
              {renderInlineNodes(Array.from(node.childNodes), { fontFamily: "Montserrat" })}
            </Text>
          </View>
        );
      }
      return;
    }

    // ---- Anything else: render its inline content as a paragraph ----
    if ((node.textContent || "").trim()) {
      blocks.push(
        <View key={nextKey("o")} style={{ marginBottom: 4 }}>
          <Text style={BASE}>
            {renderInlineNodes(Array.from(node.childNodes), { fontFamily: "Montserrat" })}
          </Text>
        </View>
      );
    }
  };

  Array.from(wrapper.childNodes).forEach(renderBlock);

  return <View>{blocks}</View>;
};
const trimHtmlVisible = (html, limit = 4000) => {
  const container = document.createElement("div");
  container.innerHTML = html || "";

  const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
  let node;
  let count = 0;

  while ((node = walker.nextNode())) {
    const text = node.nodeValue || "";

    let newText = "";
    for (let i = 0; i < text.length; i++) {
      const char = text[i];

      // Count ONLY non-space characters
      if (char !== " ") {
        if (count >= limit) break;
        count++;
      }

      newText += char;
    }

    node.nodeValue = newText;
  }

  return container.innerHTML;
};

const renderFormattedTextSafe1 = (html) => {
  const parser = document.createElement("div");
  parser.innerHTML = html || "";

  const blocks = [];

  // universal chunk splitter
  const addTextBlock = (text) => {
    const chunks = splitIntoChunks(text, 250); // SAFE SIZE
    return chunks.map((chunk, i) => (
      <Text
        key={`t-${i}-${Math.random()}`}
        style={{ fontSize: 12, lineHeight: 1.5 }}
      >
        {chunk}
      </Text>
    ));
  };

  const processNode = (node, idx) => {
    if (node.nodeType === 3) {
      const text = node.textContent.trim();
      if (text) {
        blocks.push(
          <View key={`txt-${idx}`} style={{ marginBottom: 4 }}>
            {addTextBlock(text)}
          </View>
        );
      }
      return;
    }

    const tag = node.nodeName.toUpperCase();

    if (["P", "DIV"].includes(tag)) {
      const text = node.textContent.trim();
      if (text) {
        blocks.push(
          <View key={`p-${idx}`} style={{ marginBottom: 4 }}>
            {addTextBlock(text)}
          </View>
        );
      }
      return;
    }

    if (tag === "LI") {
      const text = node.textContent.trim();
      if (text) {
        blocks.push(
          <View
            key={`li-${idx}`}
            style={{ flexDirection: "row", marginBottom: 4, marginLeft: 10 }}
          >
            <Text style={{ marginRight: 6 }}>•</Text>
            <View style={{ flex: 1 }}>{addTextBlock(text)}</View>
          </View>
        );
      }
      return;
    }
    const fallback = node.textContent.trim();
    if (fallback) {
      blocks.push(
        <View key={`fb-${idx}`} style={{ marginBottom: 4 }}>
          {addTextBlock(fallback)}
        </View>
      );
    }
  };

  Array.from(parser.childNodes).forEach(processNode);

  return <View>{blocks}</View>;
};











const ExportSavedReportPDF = ({
  selectedOrganization,
  selectedSite,
  backgroundBrief,
  improvementOpportunityAreas,
  overallAssessmentIndicator,
  contents,
  exeSummary,
  selectedObservations,
  criticalObservations,
  conclusion,
  selectedDateTime,
  reportType,
  isSaved,
  scores,
  cumulativeScore,
  otherDetails,
  chartImage,
  scorePercent = 0,
  ReportUID,
  startDate,
  endDate,
  bestPractice,
  theWayForward,
  name,
  facilityInfo,
  introduction,
  chartImageElectrical,
  timeFrom,
  timeTo,
  briefPropertyDescription,
  numOfFloors,
  avgStaffFootfall,
  noObjectionCertificate,
  nationalBuildingCodeCategory,
  coordinationgPersonClientside,
  reportPreparedBy,
  reportReviewedBy,
  buildingName,
  classificationOfAuditObservations,
  auditScoreAnalysis,
  references
  // gaugeImageWord
}) => {
  const [pdfData, setPdfData] = useState(null); // State to store PDF data
  const [generatingPDF, setGeneratingPDF] = useState(false);
  const [updatedObservations, setUpdatedObservations] = useState([]);
  const [fethcingImages, setFetchingImages] = useState(true);
  const formatDate = (date) => {
    const day = date.getDate().toString().padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
  };
  const dateText =
    startDate.getTime() === endDate.getTime()
      ? formatDate(startDate)
      : `${formatDate(startDate)} to ${formatDate(endDate)}`;

  // console.log("guage",gaugeImageWord)
  // console.log("chart",chartImageElectrical)
  // console.log("reportType",reportType)
  const trimmedHTML = trimHtmlVisible(overallAssessmentIndicator, 4000);


  useEffect(() => {
    fetchImages(selectedObservations);
  }, []);

  const fetchImages = async (observations = []) => {
    try {
      const safeObservations = Array.isArray(observations) ? observations : [];
      const updatedObservations = await Promise.all(
        safeObservations.map(async (observation) => {
          let updatedImageUrls = [];
          if (observation.imageUrls && observation.imageUrls.length > 0) {
            updatedImageUrls = await Promise.all(
              observation.imageUrls.map(async (imageUrl) => {
                try {
                  const response = await axios.get(
                    `${config.PATH
                    }/api/image-to-base64?imageUrl=${encodeURIComponent(
                      imageUrl
                    )}`
                  );
                  if (response.status === 200) {
                    // Convert response data to base64 directly
                    return response.data;
                  } else {
                    throw new Error("Failed to fetch image");
                  }
                } catch (error) {
                  console.error("Error fetching image:", error);
                  return null;
                }
              })
            );
          }
          return { ...observation, imageUrls: updatedImageUrls };
        })
      );

      // Generate PDF after fetching images
      setUpdatedObservations(updatedObservations);
    } catch (error) {
      console.error("Error fetching images:", error);
    } finally {
      // Always release loading state so the Generate PDF button is reachable
      // even when there are no observations (renderHseTable shows the placeholder).
      setFetchingImages(false);
    }
  };
  const stripHtml = (html) => {
    if (!html) return "";
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent.replace(/\n\s*\n/g, "\n").trim();
  };
  const getDaySuffix = (day) => {
    if (day > 3 && day < 21) return "th";
    switch (day % 10) {
      case 1: return "st";
      case 2: return "nd";
      case 3: return "rd";
      default: return "th";
    }
  };

  <Text style={styles.tableCellForHistory}>
    {`${startDate.getDate()}${getDaySuffix(startDate.getDate())} ${startDate.toLocaleString("en-US", { month: "short" })} ${startDate.getFullYear()}`}
  </Text>
  const riskLevels = [
    {
      range: "≥ 85%",
      risk: "Low Risk",
      color: "#00A651",
      interpretation: "Electrical systems and controls are well maintained, only minor improvements needed.",
    },
    {
      range: "65% – 84%",
      risk: "Medium Risk",
      color: "#FFFF00",
      interpretation: "Controls are adequate but with noticeable weaknesses.",
    },
    {
      range: "25% – 64%",
      risk: "High Risk",
      color: "#FFA500",
      interpretation: "High vulnerabilities with major compliance gaps.",
    },
    {
      range: "< 25%",
      risk: "Severe Risk",
      color: "#FF0000",
      interpretation: "Controls are ineffective, urgent corrective action required.",
    },
  ];
  const maxScorePerRow = 5;
  const totalPossibleScore = scores?.length * maxScorePerRow;
  const percentageCumulative = cumulativeScore;

  const percentage =
    totalPossibleScore > 0
      ? (percentageCumulative / totalPossibleScore) * 100
      : 0;

  // Determine box color based on percentage
  let boxColor = "#FFD700"; // default (yellow)

  if (percentage >= 85) {
    boxColor = "#00A651"; // Low Risk
  } else if (percentage >= 65) {
    boxColor = "#FFFF00"; // Medium Risk
  } else if (percentage >= 25) {
    boxColor = "#FFA500"; // High Risk
  } else {
    boxColor = "#FF0000"; // Severe Risk
  }
  // Risk label shown beneath the score in the indicator box, matching the modal
  // and Word export. Derived from the same value as the displayed percentage.
  const indicatorScore = Math.floor((cumulativeScore / 25) * 100);
  const indicatorRisk =
    indicatorScore >= 85 ? riskLevels[0]
      : indicatorScore >= 65 ? riskLevels[1]
        : indicatorScore >= 25 ? riskLevels[2]
          : riskLevels[3];

  const cleanHTMLBackgroundBrief = normalizeBullets(backgroundBrief);
  const cleanHTMLUnderstandingreport = normalizeBullets(contents)
  const cleanHTMLExesummary = normalizeBullets(exeSummary);
  const cleanHTMLimprovement = normalizeBullets(improvementOpportunityAreas);
  const cleanHTMLTheWayForward = normalizeBullets(theWayForward);
  const cleanHTMLConclusion = normalizeBullets(conclusion);
  const cleanHTMLOverall = normalizeBullets(overallAssessmentIndicator);
  // Function to generate PDF
  const generatePDF = () => {
    let particularDetail = renderParticularsTable();
    let riskTableData = renderRiskLevelTable();
    let auditDescriptionTable = renderAuditDescriptionTable();

    let referencesTable = renderReferencesTable();

    toast.warning("Generating PDF please wait...");
    const pdfDocument = (
      <Document>



        {/* for electrical */}
        {reportType !== "HSE" ?
          <Page size="A4" orientation="portrait"
          // style={styles.page}
          >
            {/* <View style={styles.footer}>
            <Text style={styles.leftText}>{`Prepared by Momentum`}</Text>
            <Text
              style={styles.rightText}
              render={({ pageNumber, totalPages }) =>
                `Page ${pageNumber} of ${totalPages}`
              }
            />
          </View> */}
            <Image
              src={reportType === "HSE" ? HSE_Cover_New : Electrical_Cover_New}
              style={styles.coverImage}
            />
            {/* <View style={styles.reportDetails}>
            <Text style={styles.reportDetailsText}>
              Client : {selectedOrganization.label}
            </Text>
            <Text style={styles.reportDetailsText}>
              Location : {selectedSite.label}
            </Text>
            <Text style={styles.reportDetailsText}>
              Service : Electrical Audit
            </Text>
            <Text style={styles.reportDetailsText}>
              Date : {startDate.getTime() === endDate.getTime()
                ? `${startDate.getDate()}-${startDate.getMonth() + 1
                }-${startDate.getFullYear()}`
                : `${startDate.getDate()}-${startDate.getMonth() + 1
                }-${startDate.getFullYear()} to ${endDate.getDate()}-${endDate.getMonth() + 1
                }-${endDate.getFullYear()}`}
            </Text>
            <Link style={styles.reportDetailsLink} href="https://www.momentumindia.in" >
              www.momentumindia.in
            </Link>
          </View>
          <View style={styles.reportTitleDiv}>
            <Text style={styles.reportTitleText}>
              {reportType === "HSE" ? (
                <>
                  HSE{"\n"}Report
                </>
              ) : (
                <>
                  Electrical{"\n"}Safety{"\n"}Report
                </>
              )}
            </Text>
            <View style={styles.reportYear}>
              <View style={styles.yearLine}></View>
              <Text style={styles.reportTitleText}>{new Date().getFullYear()}</Text>
            </View>
          </View> */}
            <Text style={{ position: "absolute", top: 445, left: 105, fontSize: 14, color: "#307268" }}>
              {selectedOrganization.label}
            </Text>
            <Text style={{ position: "absolute", top: 479, left: 120, fontSize: 14, color: "#307268" }}>
              {selectedSite.label}
            </Text>
            <Text style={{ position: "absolute", top: 513, left: 106, fontSize: 14, color: "#307268" }}>
              {reportType === "HSE" ? "HSE Audit" : "Electrical Audit"}
            </Text>

            <Text style={{ position: "absolute", top: 548, left: 90, fontSize: 14, color: "#307268" }}>
              {/* {startDate.getTime() === endDate.getTime()
                ? `${startDate.getDate()}-${startDate.getMonth() + 1
                }-${startDate.getFullYear()}`
                : `${startDate.getDate()}-${startDate.getMonth() + 1
                }-${startDate.getFullYear()} to ${endDate.getDate()}-${endDate.getMonth() + 1
                }-${endDate.getFullYear()}`} */}
              {
                startDate.getTime() === endDate.getTime()
                  ? `${String(startDate.getDate()).padStart(2, '0')}-${String(startDate.getMonth() + 1).padStart(2, '0')}-${startDate.getFullYear()}`
                  : `${String(startDate.getDate()).padStart(2, '0')}-${String(startDate.getMonth() + 1).padStart(2, '0')}-${startDate.getFullYear()} to ${String(endDate.getDate()).padStart(2, '0')}-${String(endDate.getMonth() + 1).padStart(2, '0')}-${endDate.getFullYear()}`
              }

            </Text>
          </Page>
          : null}


        {/* for HSE */}
        {reportType === "HSE" ?
          <Page size="A4" orientation="portrait"
          // style={styles.page}
          >
            <Image
              src={reportType === "HSE" ? HSE_Cover_New : Electrical_Cover_New}
              style={styles.coverImageHSE}
            />

            <Text style={{ position: "absolute", top: 445, left: 105, fontSize: 14, color: "#307268" }}>
              {selectedOrganization.label}
            </Text>
            <Text style={{ position: "absolute", top: 479, left: 120, fontSize: 14, color: "#307268" }}>
              {selectedSite.label}
            </Text>
            <Text style={{ position: "absolute", top: 513, left: 106, fontSize: 14, color: "#307268" }}>
              {reportType === "HSE" ? "HSE Audit" : "Electrical Audit"}
            </Text>

            <Text style={{ position: "absolute", top: 548, left: 90, fontSize: 13, color: "#307268" }}>
              {startDate.getTime() === endDate.getTime()
                ? `${startDate.getDate()}-${startDate.getMonth() + 1
                }-${startDate.getFullYear()}`
                : `${startDate.getDate()}-${startDate.getMonth() + 1
                }-${startDate.getFullYear()} to ${endDate.getDate()}-${endDate.getMonth() + 1
                }-${endDate.getFullYear()}`}
            </Text>
          </Page>
          : null}


        {/* New cover page ends here */}
        {/* background brief for electrical  */}
        {reportType != "HSE" ?
          //         <Page size="A4" style={styles.page} orientation="portrait">
          //           {/* <Text
          //             style={styles.footer}
          //             render={({ pageNumber, totalPages }) =>
          //               `    ${selectedDateTime.split("-").reverse().join("-")}                                                  Prepared by Momentum                                                       ${pageNumber}`
          //             }
          //             fixed
          //           /> */}
          //           <View style={styles.pageTitle}>
          //             <Image src={logo} style={styles.logoImage} />
          //           </View>
          //           <Text style={[styles.pageContent, styles.heading]}>
          //             DOCUMENT HISTORY
          //           </Text>
          //           {/* was not rendering previously */}

          //           {particularDetail}

          //           <Text style={[styles.pageContent, styles.heading]}>
          //             BACKGROUND - PROJECT BRIEF
          //           </Text>
          //           <Text>{'\n'}</Text>


          //           {

          //           // <View style={styles.pageContent}>
          //           <View style={{...styles.pageContent,lineHeight:0.01,backgroundColor:"#fff8dc",padding:"15px"}}>
          //           {renderFormattedText(backgroundBrief)}
          //         </View>
          //           }

          //           <Text>{'\n\n\n'}</Text>
          //           {/* <Text style={styles.pageContent}> */}
          //             {/* <Text style={[styles.pageContent, { fontFamily: "Montserrat", fontSize: 9, fontWeight: 800,color: "#307268" }]}>{`Disclaimer: `}</Text>
          //             <Text>{'\n'}</Text>  */}
          //             {/* <Text style={[styles.pageContent, { fontSize: 9,fontFamily: "Montserrat" }]}>{`This report is based on information provided to us and our own observations during the audit. We have conducted the audit in accordance with generally accepted auditing standards. This report is provided for informational purposes only and should not be relied upon as a complete representation of the Safety of the organization's information systems. By using this information, you agree that Momentum shall be held harmless in any event.`}</Text> */}
          //           {/* <Text style={[styles.pageContent, { fontStyle: "italic",fontSize: 10,fontFamily: "Montserrat" }]}>{`This report is based on information provided and observations made during the audit. It is for informational purposes only and does not guarantee complete compliance or absolute safety. The organization is responsible for implementing corrective measures suggested in the audit report. By using this information, you agree that Momentum shall not be held responsible for any untoward events`}</Text> */}


          //           {/* </Text> */}
          //                     <Text
          //   style={{
          //     position: "absolute",
          //     bottom: 50,     
          //     left: 40,          
          //     right: 40,         
          //     fontSize: 10,
          //         paddingBottom: 30, 
          //     paddingTop: 20,
          //     fontFamily: "Montserrat",
          //     lineHeight: 1.2,
          //   }}
          // >
          //   <Text
          //     style={{
          //       fontFamily: "Montserrat",
          //       fontSize: 9,
          //       fontWeight: 800,
          //       color: "#307268",
          //     }}
          //   >
          //     Disclaimer:
          //   </Text>

          //   {"\n"}

          //   <Text
          //     style={{
          //       fontStyle: "italic",
          //       fontSize: 10,
          //       fontFamily: "Montserrat",
          //     }}
          //   >
          //     This report is based on information provided and observations made during
          //     the audit. It is for informational purposes only and does not guarantee
          //     complete compliance or absolute safety. The organization is responsible
          //     for implementing corrective measures suggested in the audit report. By
          //     using this information, you agree that Momentum shall not be held
          //     responsible for any untoward events.
          //   </Text>
          // </Text>
          //         </Page>
          <Page size="A4" style={styles.page} orientation="portrait">

            {/* HEADER */}
            <View style={styles.pageTitle}>
              <Image src={logo} style={styles.logoImage} />
            </View>

            <Text style={[styles.pageContent, styles.heading]}>
              DOCUMENT HISTORY
            </Text>

            {particularDetail}

            <Text>{'\n'}</Text>
            <Text style={[styles.pageContent, styles.heading]}>
              BACKGROUND - PROJECT BRIEF
            </Text>

            <Text>{'\n'}</Text>

            {/* BACKGROUND BRIEF CONTENT */}
            {/* <View
    style={{
      ...styles.pageContent,
      lineHeight: 0.01,
      backgroundColor: "#fff8dc",
      padding: "15px",
    }}
  >
    {renderFormattedText(backgroundBrief)}
  </View> */}
            {/* <View style={[styles.pageContent, { backgroundColor: "#fff8dc", padding: 10 }]}> */}
            <View style={[styles.pageContent, { paddingTop: 10 }]}>
              <View style={{ lineHeight: 0.01 }}>
                {/* {renderFormattedText(backgroundBrief)} */}
                {renderFormattedText(cleanHTMLBackgroundBrief)}
              </View> </View>
            <Text>{'\n\n\n'}</Text>
            <Text>{'\n\n\n'}</Text>
            <Text>{'\n\n\n'}</Text>

            <View style={{ paddingHorizontal: 40, marginTop: 20 }}>
              <Text
                style={{
                  fontFamily: "Montserrat",
                  fontSize: 9,
                  fontWeight: 800,
                  color: "#307268",
                }}
              >
                Disclaimer:
              </Text>

              <Text
                style={{
                  fontStyle: "italic",
                  fontSize: 10,
                  fontFamily: "Montserrat",
                  lineHeight: 1.2,
                }}
              >
                This report is based on information provided and observations made during
                the audit. It is for informational purposes only and does not guarantee
                complete compliance or absolute safety. The organization is responsible
                for implementing corrective measures suggested in the audit report. By
                using this information, you agree that Momentum shall not be held
                responsible for any untoward events.
              </Text>
            </View>

          </Page>

          : null}
        {/* Understanding report electrical */}
        {reportType != "HSE" ?
          <Page size="A4" style={styles.page} orientation="portrait">
            {/* <Text
            style={styles.footer}
            render={({ pageNumber, totalPages }) =>
              `    ${selectedDateTime.split("-").reverse().join("-")}                                                      Prepared by Momentum                                                           ${pageNumber}`
            }
            fixed
          /> */}
            <View style={styles.pageTitle}>


              <Image src={logo} style={styles.logoImage} />
            </View>

            <Text style={[styles.pageContent, styles.heading]}>
              UNDERSTANDING THE REPORT
            </Text>
            <Text>{'\n'}</Text> {/* Add a line break */}

            {

              <View style={{ ...styles.pageContent, lineHeight: 0.01 }}>
                {/* {renderFormattedText(contents)} */}
                {renderFormattedText(cleanHTMLUnderstandingreport)};
              </View>
            }
          </Page> : null}


        {/* executuve summary for electrical */}
        {reportType != "HSE" ?
          <Page size="A4" style={styles.page} orientation="portrait">
            {/* <Text
            style={styles.footer}
            render={({ pageNumber, totalPages }) =>
              `    ${selectedDateTime.split("-").reverse().join("-")}                                                      Prepared by Momentum                                                           ${pageNumber}`
            }
            fixed
          /> */}
            <View style={styles.pageTitle}>


              <Image src={logo} style={styles.logoImage} />
            </View>
            <Text style={[styles.pageContent, styles.heading]}>
              {reportType === "HSE" ? "2. Executive Summary" : "1. Executive Summary"}
            </Text>
            <Text>{'\n'}</Text>
            {

              //   <View style={{...styles.pageContent,lineHeight:0.01,backgroundColor:"#fff8dc",padding:"15px"}}>
              //   {renderFormattedText(exeSummary)}
              // </View>
              //  <View style={[styles.pageContent, { backgroundColor: "#fff8dc", padding: 10 }]}>
              <View style={[styles.pageContent, { paddingTop: 10 }]}>
                <View style={{ lineHeight: 0.01 }}>
                  {/* {renderFormattedText(exeSummary)} */}
                  {renderFormattedText(cleanHTMLExesummary)}
                </View> </View>
            }
          </Page> : null}

        {/* improvement opportunity areas for electrical */}
        {reportType != "HSE" ?
          <Page size="A4" style={styles.page} orientation="portrait">
            {/* <Text
            style={styles.footer}
            render={({ pageNumber, totalPages }) =>
              `    ${selectedDateTime.split("-").reverse().join("-")}                                                      Prepared by Momentum                                                           ${pageNumber}`
            }
            fixed
          /> */}
            <View style={styles.pageTitle}>


              <Image src={logo} style={styles.logoImage} />
            </View>
            <Text style={[styles.pageContent, styles.heading]}>
              2. Improvement Opportunity Areas
            </Text>
            <Text>{'\n'}</Text>
            {

              //   <View style={{...styles.pageContent,lineHeight:0.01,backgroundColor:"#fff8dc",padding:"15px"}}>
              //   {renderFormattedText(improvementOpportunityAreas)}
              // </View>
              // <View style={[styles.pageContent, { backgroundColor: "#fff8dc", padding: 10 }]}>
              <View style={[styles.pageContent, { paddingTop: 10 }]}>
                <View style={{ lineHeight: 0.01 }}>
                  {/* {renderFormattedText(improvementOpportunityAreas)} */}
                  {renderFormattedText(cleanHTMLimprovement)}
                </View>
              </View>

            }
          </Page> : null}
        {/* overall risk indicator  */}
        {reportType !== "HSE" ?
          // <Page size="A4" style={styles.page} orientation="portrait">
          //   {/* <Text
          //     style={styles.footer}
          //     render={({ pageNumber, totalPages }) =>
          //       `    ${selectedDateTime.split("-").reverse().join("-")}                                                      Prepared by Momentum                                                           ${pageNumber}`
          //     }
          //     fixed
          //   /> */}
          //   <View style={styles.pageTitle}>


          //     <Image src={logo} style={styles.logoImage} />
          //   </View>
          //   <Text style={[styles.pageContent, styles.heading]}>
          //     3. Overall Assessment Indicator
          //   </Text>
          //   <Text>{'\n'}</Text>
          //   {

          //   <View style={{...styles.pageContent,lineHeight:0.01}}>
          //   {renderFormattedText(overallAssessmentIndicator)}
          //   <Text>{'\n'}</Text>
          //   <Text style={{...styles.pageContent,lineHeight:0.01}}>Below image is for diaply purpose only </Text>
          //   {/* <Image src={gaugeImageWord}  /> */}
          // </View>

          //   }
          // </Page>
          <Page size="A4" style={styles.page} orientation="portrait">
            <View style={styles.pageTitle}>
              <Image src={logo} style={styles.logoImage} />
            </View>

            <Text style={[styles.pageContent, styles.heading, { marginLeft: 40 }]}>
              3. Overall Risk Assessment Indicator
            </Text>
            <Text>{'\n'}</Text>


            {/* Table-like container */}
            <View>
              {/* Overall Assessment Indicator */}
              <View style={{ flexDirection: "row", marginHorizontal: 40 }}>
                {/* Left box */}
                <View
                  style={{
                    flex: 2,
                    // Anchor the score/label to the top so they stay on the first
                    // page even when the box stretches across multiple pages.
                    justifyContent: "flex-start",
                    alignItems: "center",
                    backgroundColor: boxColor,
                    border: "1pt solid black",
                    padding: 10,
                    paddingTop: 14,
                  }}
                >
                  <Text style={{ fontSize: 24, fontWeight: "bold" }}>
                    {`${Math.floor((cumulativeScore / 25) * 100)}%`}
                  </Text>
                  <Text style={{ fontSize: 12, fontWeight: "bold", marginTop: 4, color: "#000000" }}>
                    {indicatorRisk?.risk || ""}
                  </Text>
                </View>


                {/* Right box */}
                <View
                  style={{
                    flex: 8,
                    borderTop: "1pt solid black",
                    borderRight: "1pt solid black",
                    borderBottom: "1pt solid black",
                    padding: 4,
                    fontSize: 12,
                    backgroundColor: "#ffffff",
                  }}
                >
                  {/* {renderFormattedText(overallAssessmentIndicator)} */}
                  {/* {renderFormattedTextSafe(overallAssessmentIndicator)} */}
                  {/* {renderFormattedTextSafe1(overallAssessmentIndicator)} */}
                  {renderFormattedTextSafe(trimmedHTML)}


                </View>
              </View>

              {/* Risk Legend Heading */}
              <Text
                style={[
                  styles.pageContent,
                  styles.heading,
                  { marginTop: 20, marginLeft: 40 },
                ]}
              >
                Risk Legend
              </Text>
              {/* <view>
      <Text   style={[
          styles.pageContent,
          { marginTop: 20, marginLeft: 40 },
        ]}> The above image is for display purposes only.</Text>
</view> */}
              {/* Risk Legend Table */}
              <View>
                {renderRiskLevelTable()}
              </View>

            </View>
          </Page>

          : null}

        {/* obervations table */}

        {reportType != "HSE" ?
          <Page size="A4" style={styles.page} orientation="landscape">
            {/* <Text
            style={styles.footer}
            render={({ pageNumber, totalPages }) =>
              `    ${selectedDateTime.split("-").reverse().join("-")}                                                                               Prepared by Momentum                                                                                           ${pageNumber}`
            }
            fixed
          /> */}
            <View style={styles.pageTitle}>
              <Image src={logo} style={styles.logoImage} />
            </View>
            <Text style={[styles.pageContent, styles.heading]}>
              4. Critical Observations, Recommendations & Reasoning - Electrical Report
            </Text>
            <Text>{'\n'}</Text>
            <view style={{ marginHorizontal: 40 }}>
              {reportType === "HSE" ? renderHseTable() : renderTable()}</view>
          </Page> : null}


        {/* scoring Table */}

        {reportType != "HSE" ? <Page size="A4" style={styles.page} orientation="portrait">
          {/* Page 6: Scores */}
          {/* <Text
              style={styles.footer}
              render={({ pageNumber, totalPages }) =>
                `    ${selectedDateTime.split("-").reverse().join("-")}                                                      Prepared by Momentum                                                           ${pageNumber}`
              }
              fixed
            /> */}
          <View style={styles.pageTitle}>

            <Image src={logo} style={styles.logoImage} />
          </View>
          <Text style={[styles.pageContent, styles.heading, { marginLeft: 40 }]}>
            5. Scoring Table
          </Text>
          <Text>{'\n'}</Text>
          <view style={{ marginHorizontal: 40 }}>
            {renderScoreTable()} </view>
        </Page> : null}

        {/* way forward electrical  */}
        {reportType != "HSE" ?
          <Page size="A4" style={styles.page} orientation="portrait">
            {/* Page 7: Conclusion */}
            {/* <Text
            style={styles.footer}
            render={({ pageNumber, totalPages }) =>
              `    ${selectedDateTime.split("-").reverse().join("-")}                                                      Prepared by Momentum                                                           ${pageNumber}`
            }
            fixed
          /> */}
            <View style={styles.pageTitle}>


              <Image src={logo} style={styles.logoImage} />
            </View>
            <Text style={[styles.pageContent, styles.heading]}>
              {reportType === "HSE" ? "8. Way Forward Plan" : "6. Way Forward Plan"}
            </Text>
            <Text>{'\n'}</Text> {/* Add a line break */}
            {/* {theWayForward.split("\n").map((line, index) => ( */}
            {
              // theWayForwardParagraph.split("\n").map((line, index) => (
              //   <Text key={index} style={styles.pageContent}>
              //     &nbsp;{line}
              //   </Text>
              // ))
              // <View style={styles.pageContent}>
              //   <View style={{...styles.pageContent,lineHeight:0.01,backgroundColor:"#fff8dc",padding:"15px"}}>
              //   {renderFormattedText(theWayForward)}
              // </View>
              //  <View style={[styles.pageContent, { backgroundColor: "#fff8dc", padding: 10 }]}>
              <View style={[styles.pageContent, { paddingTop: 10 }]}>
                <View style={{ lineHeight: 0.01 }}>
                  {/* {renderFormattedText(theWayForward)} */}
                  {renderFormattedText(cleanHTMLTheWayForward)}
                </View> </View>
            }
            <Text>{'\n'}</Text>
            <Text>{'\n'}</Text>
            <Text>{'\n'}</Text>
            <Text style={[styles.pageContent, styles.heading]}>
              {reportType === "HSE" ? "9. Conclusion" : "7. Conclusion"}
            </Text>
            <Text>{'\n'}</Text> {/* Add a line break */}

            {

              // <View style={styles.pageContent}>
              //     <View style={{...styles.pageContent,lineHeight: 1.5, marginBottom: 10,backgroundColor:"#fff8dc",padding:"15px"}}>
              //     {renderFormattedText(conclusion)}
              // </View>
              // <View style={[styles.pageContent, { backgroundColor: "#fff8dc", padding: 10 }]}>
              <View style={[styles.pageContent, { paddingTop: 10 }]}>
                <View style={{ lineHeight: 0.01 }}>
                  {/* {renderFormattedText(conclusion)} */}
                  {renderFormattedText(cleanHTMLConclusion)}
                </View> </View>
            }
            <Text>{'\n'}</Text>
            <Text>{'\n'}</Text>
            <Text style={{ textAlign: "center", fontSize: 20, color: "#307268" }}>"Momentum - Empowering Progress"</Text>
          </Page> : null}


        {/* understanding report hse */}
        {reportType === "HSE" ?
          <Page size="A4" style={styles.page} orientation="portrait">
            {/* <Text
            style={styles.footer}
            render={({ pageNumber, totalPages }) =>
              `    ${selectedDateTime.split("-").reverse().join("-")}                                                      Prepared by Momentum                                                           ${pageNumber}`
            }
            fixed
          /> */}
            <View style={styles.pageTitle}>


              <Image src={logo} style={styles.logoImage} />
            </View>

            <Text style={[styles.pageContent, styles.heading]}>
              Understanding the report
            </Text>
            <Text>{'\n'}</Text> {/* Add a line break */}

            {

              <View style={{ ...styles.pageContent, lineHeight: 0.01 }}>
                {renderFormattedText(contents)}
              </View>

            }
            <Text>{'\n'}</Text>
            <Text style={styles.pageContent}>
              <Text style={[styles.pageContent, { fontFamily: "Montserrat", fontSize: 9, fontWeight: 800, color: "#307268" }]}>{`Disclaimer: `}</Text>
              <Text>{'\n'}</Text>
              <Text style={[styles.pageContent, { fontStyle: "italic", fontSize: 10, fontFamily: "Montserrat" }]}>{`This report is based on information provided and observations made during the audit. It is for informational purposes only and does not guarantee complete compliance or absolute safety. The organization is responsible for implementing corrective measures suggested in the audit report. By using this information, you agree that Momentum shall not be held responsible for any untoward events`}</Text>

            </Text>
          </Page> : null}

        {/* Audit Description hse */}
        {reportType === "HSE" ?
          <Page size="A4" style={styles.page} orientation="portrait">

            {/* Page Title and Logo */}
            <View style={styles.pageTitle}>
              <Image src={logo} style={styles.logoImage} />
            </View>

            {/* Page Heading */}
            {/* <Text style={[styles.pageContent, styles.heading]}>
              Audit Description
            </Text> */}
            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
              <Text style={[styles.pageContentHeading, styles.heading, styles.marginRight = "0px"]}>
                Audit Description
              </Text>

              <Text style={{ fontSize: 10 }}>
                (It changes based on the audit)
              </Text>
            </View>

            {/* <Text>{'\n'}</Text> */}
            <view> {auditDescriptionTable}</view>
          </Page> : null}

        {/* Classification of Auidt Observations hse*/}
        {reportType == "HSE" ?
          <Page size="A4" style={styles.page} orientation="portrait">
            <View style={styles.pageTitle}>


              <Image src={logo} style={styles.logoImage} />
            </View>

            <Text style={[styles.pageContent, styles.heading]}>
              Classification of Audit Observations
            </Text>
            <Text>{'\n'}</Text>
            {

              <View style={{ ...styles.pageContent, lineHeight: 0.01, backgroundColor: "#fff8dc", padding: "15px" }}>
                {renderFormattedTextSafe(classificationOfAuditObservations)}
              </View>
            }
          </Page> : null}

        {/* Audit Objective of HSE */}
        {reportType == "HSE" ?
          <Page size="A4" style={styles.page} orientation="portrait">
            <View style={styles.pageTitle}>


              <Image src={logo} style={styles.logoImage} />
            </View>

            {/* <Text style={[styles.pageContent, styles.heading]}>
            Audit Objective
          </Text> */}
            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
              <Text style={[styles.pageContentHeading, styles.heading, styles.marginRight = "0px"]}>
                Audit Objective
              </Text>

              <Text style={{ fontSize: 10 }}>
                (It changes based on the audit)
              </Text>
            </View>
            <Text>{'\n'}</Text>
            {

              <View style={{ ...styles.pageContent, lineHeight: 0.01, backgroundColor: "#fff8dc", padding: "15px" }}>
                {renderFormattedText(backgroundBrief)}
              </View>
            }
          </Page> : null}

        {/* Exe summary hse */}
        {reportType == "HSE" ?
          <Page size="A4" style={styles.page} orientation="portrait">
            <View style={styles.pageTitle}>


              <Image src={logo} style={styles.logoImage} />
            </View>

            {/* <Text style={[styles.pageContent, styles.heading]}>
            Executive Summary
          </Text> */}
            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
              <Text style={[styles.pageContentHeading, styles.heading, styles.marginRight = "0px"]}>
                Executive Summary
              </Text>

              <Text style={{ fontSize: 10 }}>
                (It changes based on the audit)
              </Text>
            </View>
            <Text>{'\n'}</Text>
            {

              //   <View style={{...styles.pageContent,lineHeight:0.01,backgroundColor:"#fff8dc",padding:"15px"}}>
              //   {renderFormattedText(exeSummary)}
              // </View>
              <View style={[styles.pageContent, { backgroundColor: "#fff8dc", padding: 10 }]}>
                <View style={{ lineHeight: 0.01 }}>
                  {renderFormattedText(exeSummary)}
                </View> </View>
            }
          </Page> : null}

        {/* Audit scroe analysis  */}
        {reportType == "HSE" ?
          <Page size="A4" style={styles.page} orientation="portrait">
            <View style={styles.pageTitle}>


              <Image src={logo} style={styles.logoImage} />
            </View>

            {/* <Text style={[styles.pageContent, styles.heading]}>
            Audit Score Analysis
          </Text> */}
            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
              <Text style={[styles.pageContentHeading, styles.heading, styles.marginRight = "0px"]}>
                Audit Score Analysis
              </Text>

              <Text style={{ fontSize: 10 }}>
                (It changes based on the audit)
              </Text>
            </View>
            <Text>{'\n'}</Text>
            {

              <View style={{ ...styles.pageContent, lineHeight: 0.01, backgroundColor: "#fff8dc", padding: "15px" }}>
                {renderFormattedText(auditScoreAnalysis)}
              </View>
            }
          </Page> : null}


        {/* improvement opportunity areas for hse */}
        {reportType == "HSE" ?
          <Page size="A4" style={styles.page} orientation="portrait">
            {/* <Text
            style={styles.footer}
            render={({ pageNumber, totalPages }) =>
              `    ${selectedDateTime.split("-").reverse().join("-")}                                                      Prepared by Momentum                                                           ${pageNumber}`
            }
            fixed
          /> */}
            <View style={styles.pageTitle}>


              <Image src={logo} style={styles.logoImage} />
            </View>
            {/* <Text style={[styles.pageContent, styles.heading]}>
           Improvement Opportunity Areas 
          </Text> */}
            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
              <Text style={[styles.pageContentHeading, styles.heading, styles.marginRight = "0px"]}>
                Improvement Opportunity Areas
              </Text>

              <Text style={{ fontSize: 10 }}>
                (Deductibles - It changes based on the audit)
              </Text>
            </View>
            <Text>{'\n'}</Text>
            {

              <View style={{ ...styles.pageContent, lineHeight: 0.01, backgroundColor: "#fff8dc", padding: "15px" }}>
                {renderFormattedText(improvementOpportunityAreas)}
              </View>
            }
          </Page> : null}
        {/* overall risk indicator hse  */}
        {reportType == "HSE" ?
          <Page size="A4" style={styles.page} orientation="portrait">
            <View style={styles.pageTitle}>
              <Image src={logo} style={styles.logoImage} />
            </View>

            <Text
              style={[
                styles.pageContent,
                styles.heading,
                { marginTop: 20, marginLeft: 40 },
              ]}
            >
              Overall Assessment Indicator
            </Text>
            <Text>{'\n'}</Text>

            <View>

              <View style={{ flexDirection: "row", marginHorizontal: 40 }}>

                <View
                  style={{
                    flex: 2,
                    // Anchor the score/label to the top so they sit at a consistent
                    // position regardless of how much content the right box holds.
                    // (A fixed downward offset was previously used to fake page-1
                    // centering, but it jammed the score to the bottom of the box
                    // whenever the assessment text was short.)
                    justifyContent: "flex-start",
                    alignItems: "center",
                    backgroundColor: currentRisk?.color || "#FFD700",
                    border: "1pt solid black",
                    padding: 10,
                    paddingTop: 14,
                  }}
                >
                  <Text
                    style={{
                      fontSize: 24,
                      fontWeight: "bold",
                      color: "#000",
                    }}
                  >
                    {scorePercent}%
                  </Text>

                  <Text
                    style={{
                      marginTop: 8,
                      fontSize: 12,
                      fontWeight: "bold",
                      textAlign: "center",
                      color: "#000",
                    }}
                  >
                    {currentRisk?.risk}
                  </Text>
                </View>

                <View
                  style={{
                    flex: 8,
                    borderTop: "1pt solid black",
                    borderRight: "1pt solid black",
                    borderBottom: "1pt solid black",
                    padding: 4,
                    fontSize: 12,
                    backgroundColor: "#ffffff",
                  }}
                >

                  {renderFormattedTextSafe(trimmedHTML)}
                </View>
              </View>

              <Text
                style={[
                  styles.pageContent,
                  styles.heading,
                  { marginTop: 20, marginLeft: 40 },
                ]}
              >
                Risk Legend
              </Text>

              <View>
                {renderRiskLevelTable()}
              </View>

            </View>
          </Page>
          : null}

        {/* annexure hse */}
        {reportType === "HSE" ?
          <Page size="A4" style={styles.page} orientation="portrait">

            {/* Page Title and Logo */}
            <View style={styles.pageTitle}>
              <Image src={logo} style={styles.logoImage} />
            </View>

            {/* Page Heading */}
            <Text style={[styles.pageContent, styles.heading]}>
              Annexure-References & Standards
            </Text>
            <Text>{'\n'}</Text>
            <view> {referencesTable}</view>
          </Page> : null}


        {/* obervations table hse */}

        {reportType == "HSE" ?
          <Page size="A4" style={styles.page} orientation="landscape">
            <View style={styles.pageTitle}>
              <Image src={logo} style={styles.logoImage} />
            </View>
            <Text style={[styles.pageContent, styles.heading]}>
              Critical Observations, Recommendations & Reasoning - HSE Report
            </Text>
            {/* <Text>{'\n'}</Text> */}
            <view style={{ marginHorizontal: 40 }}>
              {renderHseTable()}</view>
          </Page> : null}

        {/* {Dashboard} */}
        {reportType !== "HSE" ? (
          ""


        ) : (
          <Page size="A4" style={styles.page} orientation="portrait">
        {/* <View style={styles.footer}>
              <Text
                style={styles.footer}
                render={({ pageNumber, totalPages }) =>
                  `    ${selectedDateTime.split("-").reverse().join("-")}                                                      Prepared by Momentum                                                           ${pageNumber}`
                }
                fixed
              />
            </View> */}
        <View style={styles.pageTitle}>


              <Image src={logo} style={styles.logoImage} />
            </View>
        <Text style={[styles.pageContent, styles.heading]}>
              Dashboard
            </Text>
            {/* Constrain the snapshot to the page width and keep its aspect
                ratio so the dashboard renders on the SAME single page as the
                header/heading instead of overflowing or coming out blank. */}
            {chartImage ? (
              <Image
                src={chartImage}
                style={{ width: "90%", marginHorizontal: "5%", marginTop: 10, objectFit: "contain" }}
              />
            ) : null}
        </Page>
        )}
        {/* conclusion */}
        {reportType == "HSE" ?
          <Page size="A4" style={styles.page} orientation="portrait">
            <View style={styles.pageTitle}>


              <Image src={logo} style={styles.logoImage} />
            </View>

            <Text style={[styles.pageContent, styles.heading]}>
              Conclusion
            </Text>
            <Text>{'\n'}</Text>
            {

              //   <View style={{...styles.pageContent,lineHeight:0.01,backgroundColor:"#fff8dc",padding:"15px"}}>
              //   {renderFormattedText(conclusion)}
              //   <Text>{'\n'}</Text>
              //   <Text>{'\n'}</Text>

              // </View>
              <View style={[styles.pageContent, { backgroundColor: "#fff8dc", padding: 10 }]}>
                <View style={{ lineHeight: 0.01 }}>
                  {renderFormattedText(conclusion)}
                  <Text>{'\n'}</Text>
                  <Text>{'\n'}</Text>
                </View> </View>
            }
            <Text>{'\n'}</Text>
            <Text>{'\n'}</Text>
            <Text style={{ textAlign: "center", fontSize: 20, color: "#307268" }}>"Momentum - Empowering Progress"</Text>
          </Page> : null}

      </Document>
    );

    // Simulate PDF generation delay
    setTimeout(() => {
      setPdfData(pdfDocument);
      toast.success("PDF generation complete. Creating download link.");
    }, 5000); // Adjust the timeout based on your actual PDF generation time

  };

  //   const renderScoreTable = () => {
  //    const customStyles = {
  //   table: {
  //     width: "100%",
  //     // borderWidth: 1,
  //     borderColor: "#000",
  //     borderStyle: "solid",
  //   },

  //   tableRow: {
  //     flexDirection: "row",
  //   },

  //   col1: { width: "55%",borderLeftWidth: 1,  },
  //   col2: { width: "22.5%" },
  //   col3: { width: "22.5%" },

  //   headerCell: {
  //     backgroundColor: "#307268",
  //     color: "#efc71d",
  //     padding: 6,
  //     fontSize: 12,
  //     fontWeight: "bold",
  //     borderRightWidth: 1,
  //     borderColor: "#000",
  //     textAlign: "center",
  //   },

  //   headerCellLeft: {
  //     backgroundColor: "#307268",
  //     color: "#efc71d",
  //     padding: 6,
  //     fontSize: 12,
  //     fontWeight: "bold",
  //     borderRightWidth: 1,
  //     borderLeftWidth: 1,   
  //     borderColor: "#000",
  //     textAlign: "left",
  //   },

  //   // Normal table cells
  //   cellLeft: {
  //     padding: 6,
  //     fontSize: 12,
  //     // backgroundColor: "#f5f5f5",
  //     borderRightWidth: 1,
  //     borderBottomWidth: 1,
  //     borderLeftWidth: 1, 
  //     borderColor: "#000",
  //     textAlign: "left",
  //   },

  //   cellCenter: {
  //     padding: 6,
  //     fontSize: 12,
  //     // backgroundColor: "#f5f5f5",
  //     borderRightWidth: 1,
  //     borderBottomWidth: 1,
  //     borderColor: "#000",
  //     textAlign: "center",
  //   },

  //   // Cumulative row
  //   cumulativeCell: {
  //     padding: 6,
  //     fontSize: 12,
  //     backgroundColor: "#efc71d",
  //     borderRightWidth: 1,
  //     borderBottomWidth: 1,
  //     borderColor: "#000",
  //     textAlign: "center",
  //     fontWeight: "bold",
  //   }
  // };


  //     return (
  //       <View>
  //        <View style={customStyles.table}>

  //   {/* HEADER */}
  //   <View style={customStyles.tableRow}>
  //     <Text style={[customStyles.headerCellLeft, customStyles.col1]}>Parameter</Text>
  //     <Text style={[customStyles.headerCell, customStyles.col2]}>Max Score</Text>
  //     <Text style={[customStyles.headerCell, customStyles.col3]}>Score Obtained</Text>
  //   </View>

  //   {/* BODY ROWS */}
  //   {scores.map((row, index) => (
  //     <View key={index} style={customStyles.tableRow}>
  //       <Text style={[customStyles.cellLeft, customStyles.col1]}>
  //         {row["Electrical Safety"]}
  //       </Text>

  //       <Text style={[customStyles.cellCenter, customStyles.col2]}>
  //         {row["Maximum Score"]}
  //       </Text>

  //       <Text style={[customStyles.cellCenter, customStyles.col3]}>
  //         {row["Score Obtained"]}
  //       </Text>
  //     </View>
  //   ))}
  //   <View style={customStyles.tableRow}>
  //     <Text style={[customStyles.cumulativeCell, customStyles.col1]}>Cumulative</Text>
  //     <Text style={[customStyles.cumulativeCell, customStyles.col2]}>25</Text>
  //     <Text style={[customStyles.cumulativeCell, customStyles.col3]}>{cumulativeScore}</Text>
  //   </View>

  // </View>

  //                               <Text style={{ color: "#307268",marginTop:"20px",
  //                     marginBottom:"70px"
  //                    }}>Overall Score: <Text style={{ color: "#a3a300",fontSize: 15 }}>{((cumulativeScore / 25) * 100).toFixed(2)}%</Text></Text>
  //      <Image src={chartImageElectrical} style={{ width: 500, height: 330, 
  //       // marginLeft:"100px",
  //       marginTop:"5px"
  //       }} />
  //       </View>
  //     );
  //   };



  const renderScoreTable = () => {
    const customStyles = {
      table: {
        width: "100%",
        borderColor: "#000",
        borderStyle: "solid"
      },

      tableRow: {
        flexDirection: "row",
      },

      col1: { width: "55%", borderLeftWidth: 1 },
      col2: { width: "22.5%" },
      col3: { width: "22.5%" },

      headerCell: {
        backgroundColor: "#307268",
        color: "#efc71d",
        padding: 6,
        fontSize: 12,
        fontWeight: "bold",
        borderRightWidth: 1,
        borderColor: "#000",
        textAlign: "center",
      },

      headerCellLeft: {
        backgroundColor: "#307268",
        color: "#efc71d",
        padding: 6,
        fontSize: 12,
        fontWeight: "bold",
        borderRightWidth: 1,
        borderLeftWidth: 1,
        borderColor: "#000",
        textAlign: "left",
      },

      cellLeft: {
        padding: 6,
        fontSize: 12,
        borderRightWidth: 1,
        borderBottomWidth: 1,
        borderLeftWidth: 1,
        borderColor: "#000",
        textAlign: "left",
      },

      cellCenter: {
        padding: 6,
        fontSize: 12,
        borderRightWidth: 1,
        borderBottomWidth: 1,
        borderColor: "#000",
        textAlign: "center",
      },

      cumulativeCell: {
        padding: 6,
        fontSize: 12,
        backgroundColor: "#efc71d",
        borderRightWidth: 1,
        borderBottomWidth: 1,
        borderColor: "#000",
        textAlign: "center",
        fontWeight: "bold",
      }
    };

    return (
      <View>
        <View style={customStyles.table}>

          {/* HEADER */}
          <View style={customStyles.tableRow}>
            <Text style={[customStyles.headerCellLeft, customStyles.col1]}>Parameter</Text>
            <Text style={[customStyles.headerCell, customStyles.col2]}>Max Score</Text>
            <Text style={[customStyles.headerCell, customStyles.col3]}>Score Obtained</Text>
          </View>

          {/* BODY (ID-BASED SAFE MAPPING) */}
          {scores.map((row) => (
            <View key={row.id} style={customStyles.tableRow}>
              <Text style={[customStyles.cellLeft, customStyles.col1]}>
                {row.parameter}
              </Text>

              <Text style={[customStyles.cellCenter, customStyles.col2]}>
                {row.MaximumScore}
              </Text>

              <Text style={[customStyles.cellCenter, customStyles.col3]}>
                {row.ScoreObtained}
              </Text>
            </View>
          ))}

          {/* CUMULATIVE ROW */}
          <View style={customStyles.tableRow}>
            <Text style={[customStyles.cumulativeCell, customStyles.col1]}>Cumulative</Text>
            <Text style={[customStyles.cumulativeCell, customStyles.col2]}>
              {scores.reduce((acc, row) => acc + row.MaximumScore, 0)}
            </Text>
            <Text style={[customStyles.cumulativeCell, customStyles.col3]}>
              {cumulativeScore}
            </Text>
          </View>

        </View>

        {/* OVERALL SCORE */}
        <Text
          style={{
            color: "#307268",
            marginTop: "20px",
            marginBottom: "70px",
          }}
        >
          Overall Score:{" "}
          <Text style={{ color: "#a3a300", fontSize: 15 }}>
            {((cumulativeScore / 25) * 100).toFixed(2)}%
          </Text>
        </Text>

        {/* BAR CHART IMAGE */}
        <Image
          src={chartImageElectrical}
          style={{
            width: 500,
            height: 330,
            marginTop: "5px",
          }}
        />
      </View>
    );
  };

  // const PdfCell = ({ value = "N/A", align = "center" }) => {
  //   const text = String(value).replace(/\s+/g, " ").trim();
  //   const chunks = text.match(/.{1,150}/g) || ["N/A"];

  //   return (
  //     <Text style={{ fontSize: 10, textAlign: align }}>
  //       {chunks.map((chunk, i) => (
  //         <Text key={i}>
  //           {chunk}
  //           {"\n"}
  //         </Text>
  //       ))}
  //     </Text>
  //   );
  // };


  const _HseRiskLevels = [
    {
      range: "≥ 85%",
      risk: "Low Risk",
      color: "#00A651",
      interpretation: "Electrical systems and controls are well maintained, only minor improvements needed.",
    },
    {
      range: "65% – 84%",
      risk: "Medium Risk",
      color: "#FFFF00",
      interpretation: "Controls are adequate but with noticeable weaknesses.",
    },
    {
      range: "25% – 64%",
      risk: "High Risk",
      color: "#FFA500",
      interpretation: "High vulnerabilities with major compliance gaps.",
    },
    {
      range: "< 25%",
      risk: "Severe Risk",
      color: "#FF0000",
      interpretation: "Controls are ineffective, urgent corrective action required.",
    },
  ];
  const getRiskLevel = (score) => {
    if (score >= 85) return _HseRiskLevels[0];
    if (score >= 65) return _HseRiskLevels[1];
    if (score >= 25) return _HseRiskLevels[2];
    return _HseRiskLevels[3];
  };

  const currentRisk = getRiskLevel(scorePercent);

  const PdfCell = ({ value = "N/A", align = "center", maxLength = 150 }) => {
    const text = String(value);

    const rawLines = text.split("\n");

    const wrappedLines = rawLines.flatMap((line) => {
      const words = line.split(" ");
      const lines = [];
      let current = "";

      words.forEach((word) => {
        if ((current + " " + word).trim().length <= maxLength) {
          current = (current + " " + word).trim();
        } else {
          lines.push(current);
          current = word;
        }
      });

      if (current) lines.push(current);
      return lines;
    });

    return (
      <Text style={{ fontSize: 9, textAlign: align }}>
        {wrappedLines.join("\n")}
      </Text>
    );
  };

  //   const renderHseTable = () => {
  //     // Group observations by table_type
  //     const groupedObservations = updatedObservations.reduce((acc, observation) => {
  //       const { table_type } = observation;
  //       if (!acc[table_type]) {
  //         acc[table_type] = [];
  //       }
  //       acc[table_type].push(observation);
  //       return acc;
  //     }, {});

  //     return (
  //     <View>
  //   {Object.keys(groupedObservations).length === 0 ||
  //   Object.values(groupedObservations).every(
  //     (obsArray) => !obsArray || obsArray.length === 0
  //   ) ? (
  //     <Text
  //       style={{
  //         fontSize: 15,
  //         textAlign: "center",
  //         marginVertical: 10,
  //         fontStyle: "italic",
  //       }}
  //     >
  //       No observations are selected
  //     </Text>
  //   ) : (
  //     Object.keys(groupedObservations).map((tableType, index) => (
  //       <View key={index}>
  //         {/* Table Type Heading */}
  //         <Text style={[styles.pageContentHSE, styles.subHeading]}>
  //           {index + 1}. {tableType}
  //         </Text>

  //         <View style={styles.tableElectrical}>
  //           <View style={styles.tableRow}>
  //             <Text style={styles.tableCellHeaderForSrNo}>Sr. No.</Text>
  //             <Text style={styles.tableCellHeader}>Area / Process</Text>
  //             <Text style={styles.tableCellHeader}>Observation</Text>
  //             <Text style={styles.tableCellHeader}>Objective Evidence</Text>
  //             <Text style={styles.tableCellHeader}>Criticality</Text>
  //             <Text style={styles.tableCellHeader}>Legal Reference (if any)</Text>
  //             <Text style={styles.tableCellHeader}>Recommendation</Text>
  //           </View>

  //           {groupedObservations[tableType].map((observation, obsIndex) => (
  //             <View key={obsIndex} style={styles.tableRow}>
  //               <Text style={styles.cellForSrNo}>{obsIndex + 1}</Text>
  //               <Text style={[styles.tableCell, { textAlign: "center" }]}>
  //                 {observation.area || "N/A"}
  //               </Text>
  //               <Text style={[styles.tableCell, { textAlign: "center" }]}>
  //                 {observation.observation || "N/A"}
  //               </Text>
  //                <View style={[styles.tableCell, { textAlign: "center" }]}>
  //                 {observation.imageUrls?.length > 0 ? (
  //                   observation.imageUrls.map((imageUrl, imgIndex) => (
  //                     <React.Fragment key={imgIndex}>
  //                       {imageUrl ? (
  //                         <Image
  //                           src={`data:image/jpeg;base64,${imageUrl}`}
  //                           style={styles.tableCellImage}
  //                         />
  //                       ) : (
  //                         <Text>N/A</Text>
  //                       )}
  //                     </React.Fragment>
  //                   ))
  //                 ) : (
  //                   <Text>N/A</Text>
  //                 )}
  //               </View>
  //               <Text style={[styles.tableCell, { textAlign: "center" }]}>
  //                 {observation.criticality || "N/A"}
  //               </Text>



  //               <Text style={[styles.tableCell, { textAlign: "center" }]}>
  //                 {observation.is_reference || "N/A"}
  //               </Text>
  //               <Text style={[styles.tableCell, { textAlign: "center" }]}>
  //                 {observation.recommendations || "N/A"}
  //               </Text>
  //             </View>
  //           ))}
  //         </View>
  //       </View>
  //     ))
  //   )}
  // </View>

  //     );
  //   };
  const renderHseTable = () => {
    // Group observations by table_type
    const groupedObservations = updatedObservations.reduce((acc, observation) => {
      const { table_type } = observation;
      if (!acc[table_type]) acc[table_type] = [];
      acc[table_type].push(observation);
      return acc;
    }, {});

    const noData =
      Object.keys(groupedObservations).length === 0 ||
      Object.values(groupedObservations).every(
        (arr) => !arr || arr.length === 0
      );

    if (noData) {
      return (
        <Text
          style={{
            fontSize: 15,
            textAlign: "center",
            marginVertical: 10,
            fontStyle: "italic",
          }}
        >
          No observations are selected
        </Text>
      );
    }

    return (
      <View>
        {Object.keys(groupedObservations).map((tableType, index) => (
          <View key={index}>
            {/* Table Heading */}
            <Text style={[styles.pageContentHSE, styles.subHeading]}>
              {index + 1}. {tableType}
            </Text>

            {/* Table */}
            <View style={styles.tableHSE}>

              {/* Header */}
              <View style={styles.tableRow}>
                <View style={styles.tableCellHeaderForSrNoHSE}>
                  <Text>Sr. No.</Text>
                </View>

                <View style={styles.tableCellHeaderHSE}>
                  <Text>Area / Process</Text>
                </View>

                <View style={styles.tableCellHeaderHSE}>
                  <Text>Equipment</Text>
                </View>

                <View style={styles.tableCellHeaderHSE}>
                  <Text>Category</Text>
                </View>

                <View style={[styles.tableCellHeaderHSE, { width: "6%" }]}>
                  <Text>Criticality</Text>
                </View>

                <View style={[styles.tableCellHeaderHSE, { width: "6%" }]}>
                  <Text>Status</Text>
                </View>

                <View style={styles.tableCellHeaderHSEObs}>
                  <Text>Observation</Text>
                </View>

                <View style={styles.tableCellHeaderHSEObs}>
                  <Text>Recommendation</Text>
                </View>

                <View style={[styles.tableCellHeaderHSE, { width: "8%" }]}>
                  <Text>Legal Reference (if any)</Text>
                </View>

                {/* NEW SCORE COLUMN */}
                <View style={styles.tableCellHeaderHSEScore}>
                  <Text>Score</Text>
                </View>

                <View style={styles.tableCellHeaderHSEPhoto}>
                  <Text>Objective Evidence</Text>
                </View>
              </View>

              {/* BODY ROWS */}
              {/* No wrap={false}: a row taller than one page must be allowed to
                  break, otherwise react-pdf crams it into the remaining space and
                  the text overlaps. Outer borders live on the row itself so the
                  table edge stays closed on every page fragment (left/right repeat
                  on each fragment, bottom only on the final one) — this keeps the
                  Score / Objective Evidence columns bordered even when a tall row
                  splits across pages. */}
              {groupedObservations[tableType].map((observation, obsIndex) => (
                <View
                  key={obsIndex}
                  style={[
                    styles.tableRow,
                    {
                      borderLeftWidth: 1,
                      borderRightWidth: 1,
                      borderBottomWidth: 1,
                      borderColor: "#000",
                    },
                  ]}
                >

                  {/* Sr No */}
                  <View style={styles.cellForSrNoHSE}>
                    <PdfCell value={obsIndex + 1} />
                  </View>

                  {/* Area / Process */}
                  <View style={styles.tableCellHSE}>
                    <PdfCell value={observation.area} />
                  </View>

                  {/* Equipment */}
                  <View style={styles.tableCellHSE}>
                    <PdfCell value={naValue(observation.equipment)} />
                  </View>

                  {/* Category */}
                  <View style={styles.tableCellHSE}>
                    <PdfCell value={naValue(observation.category)} />
                  </View>

                  {/* Criticality */}
                  <View style={[styles.tableCellHSE, { width: "6%" }]}>
                    <PdfCell value={naValue(observation.criticality)} />
                  </View>

                  {/* Status */}
                  <View style={[styles.tableCellHSE, { width: "6%" }]}>
                    <PdfCell value={naValue(observation.status)} />
                  </View>

                  {/* Observation */}
                  <View style={styles.tableCellHSEObs}>
                    {renderTextWithUnicodeBullets(naValue(observation.observation))}
                  </View>

                  {/* Recommendation */}
                  <View style={styles.tableCellHSEObs}>
                    {renderTextWithUnicodeBullets(naValue(observation.recommendations))}
                  </View>

                  {/* Legal Reference */}
                  <View style={styles.tableCellHSELegal}>
                    {renderWrappedText(naValue(observation.legal_reference), 20)}
                  </View>

                  {/* SCORE */}
                  {/* Override justifyContent to top-align: when an observation row
                      spans multiple pages every cell stretches to the full row
                      height, and the inherited `justifyContent: center` floats the
                      score to the vertical middle where it lands on a page break and
                      gets clipped (invisible). Top-aligning keeps the value on the
                      first page fragment, matching Area/Equipment/Status columns. */}
                  <View style={[styles.tableCellHSEScore, { justifyContent: "flex-start" }]}>
                    <PdfCell value={observation.score || "0"} />
                  </View>

                  {/* Objective Evidence */}
                  <View style={styles.tableCellHSEPhoto} >
                    {(() => {
                      // Keep only images that actually have data. fetchImages()
                      // returns null for any download that failed, so the raw
                      // array can be [null] — which still has length > 0 and used
                      // to slip past the N/A fallback, producing a broken
                      // "data:image/jpeg;base64,null" image that rendered nothing.
                      const validImages = (Array.isArray(observation.imageUrls)
                        ? observation.imageUrls
                        : []
                      ).filter((url) => typeof url === "string" && url.trim() !== "");

                      if (validImages.length === 0) {
                        return <PdfCell value={"N/A"} />;
                      }

                      return validImages.map((imageUrl, imgIndex) => {
                        const src = imageUrl.startsWith("data:")
                          ? imageUrl
                          : `data:image/jpeg;base64,${imageUrl}`;
                        return (
                          <View key={imgIndex} wrap={false} style={{ marginBottom: 4 }}>
                            <Image src={src} style={styles.tableCellImage} />
                          </View>
                        );
                      });
                    })()}
                  </View>

                </View>
              ))}
            </View>
          </View>
        ))}
      </View>
    );
  };


  //   const renderTable = () => {
  //     return (
  //       <View>


  //         <View style={styles.tableElectrical}>
  //           <View style={styles.tableRow}>
  //             <Text style={styles.tableCellHeaderForSrNo}>Sr. No</Text>
  //             <Text style={styles.tableCellHeader}>Area</Text>
  //             <Text style={styles.tableCellHeader}>Observation</Text>
  //             <Text style={styles.tableCellHeader}>Criticality</Text>
  //             <Text style={styles.tableCellHeader}>Recommendations</Text>
  //             <Text style={styles.tableCellHeader}>Is Reference</Text>
  //             {reportType === "HSE" ? (
  //               <Text style={styles.tableCellHeader}>Score</Text>
  //             ) : null}
  //             <Text style={styles.tableCellHeader}>Photo Evidence</Text>
  //           </View>
  //           {updatedObservations.map((observation, index) => (
  //             <View key={index} style={styles.tableRow}>
  //               {/* <Text style={styles.cellForSrNo}>{index + 1}</Text> */}
  //               <View style={[styles.cellForSrNo, {
  //   display: 'flex',
  //   alignItems: 'center',      // horizontal center
  //   justifyContent: 'center',  // vertical center
  // }]}>
  //   <Text style={{textAlign: 'center' }}>
  //     {index + 1}
  //   </Text>
  // </View>

  //               {/* <Text style={[styles.tableCell, { textAlign: 'center' }]}>
  //                 {observation.area ? observation.area : "N/A"}
  //               </Text> */}
  //               <View style={[styles.tableCell, {
  //   display: 'flex',
  //   alignItems: 'center',         // horizontal center
  //   justifyContent: 'center',     // vertical center
  // }]}>
  //   <Text style={{ textAlign: 'center' }}>
  //     {observation.area ? observation.area : "N/A"}
  //   </Text>
  // </View>
  //               {/* <Text style={[styles.tableCell, { textAlign: 'center' }]}>
  //                 {observation.observation ? observation.observation : "N/A"}
  //               </Text> */}
  //               <View style={[styles.tableCell, {
  //   display: 'flex',
  //   alignItems: 'center',         // horizontal center
  //   justifyContent: 'center',     // vertical center
  // }]}>
  //   <Text style={{ textAlign: 'center' }}>
  //     {/* {observation.observation? observation.observation : "N/A"} */}
  //     {observation.observation 
  //   ? observation.observation.replace(/\s+/g, ' ').trim() 
  //   : "N/A"
  // }

  //   </Text>
  // </View>
  //               {/* <Text style={[styles.tableCell, { textAlign: 'center' }]}>
  //                 {observation.criticality ? observation.criticality : "N/A"}
  //               </Text> */}
  //               <View style={[styles.tableCell, {
  //   display: 'flex',
  //   alignItems: 'center',         // horizontal center
  //   justifyContent: 'center',     // vertical center
  // }]}>
  //   <Text style={{ textAlign: 'center' }}>
  //     {observation.criticality ? observation.criticality : "N/A"}
  //   </Text>
  // </View>
  //               {/* <Text style={[styles.tableCell, { textAlign: 'center' }]}>
  //                 {observation.recommendations ? observation.recommendations : "N/A"}
  //               </Text> */}
  //               <View style={[styles.tableCell, {
  //   display: 'flex',
  //   alignItems: 'center',         // horizontal center
  //   justifyContent: 'center',     // vertical center
  // }]}>
  //   <Text style={{ textAlign: 'center' }}>
  //     {observation.recommendations ? observation.recommendations : "N/A"}
  //   </Text>
  // </View>
  //               {/* <Text style={[styles.tableCell, { textAlign: 'center' }]}>
  //                 {observation.is_reference ? observation.is_reference : "N/A"}
  //               </Text> */}
  //               <View style={[styles.tableCell, {
  //   display: 'flex',
  //   alignItems: 'center',         // horizontal center
  //   justifyContent: 'center',     // vertical center
  // }]}>
  //   <Text style={{ textAlign: 'center' }}>
  //     {observation.is_reference ? observation.is_reference : "N/A"}
  //   </Text>
  // </View>
  //               {reportType === "HSE" ? (
  //                 // <Text style={styles.tableCell}>
  //                 //   {observation.score ? observation.score : "N/A"}
  //                 // </Text>
  //                  <View style={[styles.tableCell, {
  //     display: 'flex',
  //     alignItems: 'center',
  //     justifyContent: 'center',
  //   }]}>
  //     <Text style={{ textAlign: 'center' }}>
  //       {observation.score ? observation.score : "N/A"}
  //     </Text>
  //   </View>
  //               ) : null}
  //               <View style={styles.tableCell}>
  //                 {observation.imageUrls && observation.imageUrls.length > 0 ? (
  //                   observation.imageUrls.map((imageUrl, imgIndex) => (
  //                     <React.Fragment key={imgIndex}>
  //                       <Text>{""}</Text> {/* Add an empty string before every image */}
  //                       {imageUrl ? (
  //                         <Image
  //                           src={`data:image/jpeg;base64,${imageUrl}`}
  //                           style={styles.tableCellImage}
  //                         />
  //                       ) : (
  //                         <Text key={`na-${imgIndex}`}>N/A</Text>
  //                       )}
  //                     </React.Fragment>
  //                   ))
  //                 ) : (
  //                   // <Text style={{textAlign:"center"}}>N/A</Text>
  //        <View
  //   style={{
  //     flex: 1,                      
  //     width: '100%',                  
  //     display: 'flex',
  //     flexDirection: 'column',
  //     alignItems: 'center',           
  //     justifyContent: 'center',      
  //   }}
  // >
  //   <Text style={{ textAlign: 'center' }}>N/A</Text>
  // </View>

  //                 )}
  //               </View>
  //             </View>
  //           ))}
  //         </View>
  //       </View>
  //     );
  //   };




  const renderTable = () => {
    return (
      <View>
        <View style={styles.tableElectrical}>
          {/* Header */}
          <View style={styles.tableRow}>
            <Text style={styles.tableCellHeaderForSrNoElectrical}>Sr. No</Text>
            <Text style={styles.tableCellHeaderElectrical}>Area</Text>
            <Text style={[styles.tableCellHeaderElectricalObs]}>Observation</Text>
            <Text style={styles.tableCellHeaderElectrical}>Criticality</Text>
            <Text style={styles.tableCellHeaderElectricalRec}>Recommendations</Text>
            <Text style={styles.tableCellHeaderElectrical}>Is Reference</Text>
            <Text style={styles.tableCellHeaderElectricalPhoto}>Photo Evidence</Text>
          </View>

          {/* Rows */}
          {updatedObservations.map((observation, index) => (
            <View key={index} style={styles.tableRow}>

              {/* Sr No */}
              <View style={styles.cellForSrNoElectrical}>
                <PdfCell value={index + 1} />
              </View>

              {/* Area */}
              <View style={styles.tableCellElectrical}>
                <PdfCell value={observation.area || "N/A"} align="left" />
              </View>

              {/* Observation */}
              <View style={styles.tableCellElectricalObs}>
                {renderTextWithUnicodeBullets(observation.observation || "N/A")}
              </View>

              {/* Criticality */}
              <View style={styles.tableCellElectrical}>
                <PdfCell value={observation.criticality || "N/A"} />
              </View>

              {/* Recommendations */}
              <View style={styles.tableCellElectricalRec}>
                {renderTextWithUnicodeBullets(observation.recommendations || "N/A")}
              </View>

              {/* Is Reference */}
              <View style={styles.tableCellElectrical}>
                <PdfCell value={observation.is_reference || "N/A"} />
              </View>


              {/* Photo Evidence */}
              <View style={styles.tableCellElectricalPhoto} >
                {Array.isArray(observation.imageUrls) && observation.imageUrls.length > 0 ? (
                  observation.imageUrls.map((imageUrl, imgIndex) => {
                    const src = imageUrl?.startsWith("data:") ? imageUrl : `data:image/jpeg;base64,${imageUrl}`;
                    return (
                      <View key={imgIndex} style={{ marginBottom: 4 }}>
                        {src ? (
                          <Image src={src} style={styles.tableCellImage} />
                        ) : (
                          <Text>N/A</Text>
                        )}
                      </View>
                    );
                  })
                ) : (
                  <PdfCell value={"N/A"} />
                )}
              </View>

            </View>
          ))}
        </View>
      </View>
    );
  };

  // const renderParticularsTable = () => {
  //     return (
  //       <View>
  //         <View style={styles.tableForHistory}>
  //           {/* Row for 'Date of Visit' */}
  //           {/* <View style={styles.tableRow}>
  //             <Text style={styles.tableCellHeaderForHistory}>PARTICULARS</Text>
  //             <Text style={styles.tableCellHeaderForHistory}>DETAILS</Text>
  //           </View> */}

  //           <View style={{ flexDirection: "row" }}>
  //   <Text
  //     style={{
  //       width: "50%",
  //       backgroundColor: "#efc71d",
  //       padding: 5,
  //       borderStyle: "solid",
  //       borderColor: "black",
  //       borderWidth: 1,
  //       fontSize: 11,
  //       fontWeight: "bold",
  //       textAlign: "center",      // Center text horizontally
  //       justifyContent: "center", // Center content (React Native PDF support)
  //       alignItems: "center",     // Center content vertically
  //     }}
  //   >
  //     PARTICULARS
  //   </Text>

  //   <Text
  //     style={{
  //       width: "50%",
  //       backgroundColor: "#efc71d",
  //       padding: 5,
  //       borderStyle: "solid",
  //       borderColor: "black",
  //       borderWidth: 1,
  //       fontSize: 11,
  //       fontWeight: "bold",
  //       textAlign: "center",      // Center text horizontally
  //       justifyContent: "center",
  //       alignItems: "center",
  //     }}
  //   >
  //     DETAILS
  //   </Text>
  // </View>

  //           {/* Row for 'Date of Visit' */}
  //           <View style={styles.tableRow}>
  //             <Text style={styles.tableCellForHistory}>Date of Visit</Text>
  //             {/* <Text style={styles.tableCellForHistory}>
  //               {startDate.getTime() === endDate.getTime()
  //                 ? `${startDate.getDate()}-${(startDate.getMonth() + 1).toString().padStart(2, '0')}-${startDate.getFullYear()}`
  //                 : `${startDate.getDate()}-${(startDate.getMonth() + 1).toString().padStart(2, '0')}-${startDate.getFullYear()} to ${endDate.getDate()}-${(endDate.getMonth() + 1).toString().padStart(2, '0')}-${endDate.getFullYear()}`}
  //             </Text> */}
  // <Text style={styles.tableCellForHistory}>
  //   {`${startDate.getDate()}${getDaySuffix(startDate.getDate())} ${startDate.toLocaleString("en-US", { month: "short" })} ${startDate.getFullYear()}`}
  // </Text>
  //           </View>



  //           <View style={styles.tableRow}>
  //             <Text style={styles.tableCellForHistory}>Document Prepared By</Text>
  //             <Text style={styles.tableCellForHistory}>{name}</Text>
  //           </View>

  //           <View style={styles.tableRow}>
  //             <Text style={styles.tableCellForHistory}>Date of Document Submission</Text>
  //             <Text style={styles.tableCellForHistory}>{selectedDateTime.split("-").reverse().join("-")}</Text>
  //           </View>

  //           {/* <View style={styles.tableRow}>
  //             <Text style={styles.tableCellForHistory}>Document Version</Text>
  //             <Text style={styles.tableCellForHistory}></Text>
  //           </View> */}
  //         </View>
  //       </View>
  //     );
  //   };

  const renderParticularsTable = () => {
    return (
      <View style={styles.particularTableContainer}>

        {/* HEADER */}
        <View style={styles.particularTableRow}>
          <View style={styles.particularTableHeaderCell}>
            <Text style={styles.particularTableHeaderText}>PARTICULARS</Text>
          </View>

          <View style={styles.particularTableHeaderCell}>
            <Text style={styles.particularTableHeaderText}>DETAILS</Text>
          </View>
        </View>

        {/* ROW 1 */}
        <View style={styles.particularTableRow}>
          <View style={styles.particularTableCell}>
            <Text style={styles.particularTableCellText}>Date of Visit</Text>
          </View>

          <View style={styles.particularTableCell}>
            <Text style={styles.particularTableCellText}>
              {dateText}

              {/* {`${startDate.getDate()}${getDaySuffix(startDate.getDate())} ${startDate.toLocaleString("en-US", { month: "short" })} ${startDate.getFullYear()}`} */}
            </Text>
          </View>
        </View>

        {/* ROW 2 */}
        <View style={styles.particularTableRow}>
          <View style={styles.particularTableCell}>
            <Text style={styles.particularTableCellText}>Document Prepared By</Text>
          </View>

          <View style={styles.particularTableCell}>
            <Text style={styles.particularTableCellText}>{name}</Text>
          </View>
        </View>

        {/* ROW 3 */}
        <View style={styles.particularTableRow}>
          <View style={styles.particularTableCelllast}>
            <Text style={styles.particularTableCellText}>Date of Document Submission</Text>
          </View>

          <View style={styles.particularTableCelllast}>
            <Text style={styles.particularTableCellText}>
              {selectedDateTime.split("-").reverse().join("-")}
            </Text>
          </View>
        </View>

      </View>
    );
  };

  const renderRiskLevelTable = () => (
    // wrap={false} keeps the whole legend (header + rows) on one page so a row
    // can't split across a page break and lose its Score Range column.
    <View wrap={false} style={styles.riskTable}>

      {/* HEADER ROW */}
      <View wrap={false} style={[styles.row, { borderBottom: "1pt solid #000" }]}>
        <View style={styles.colScoreHeader}>
          <Text style={styles.headerText}>Score Range</Text>
        </View>
        <View style={styles.colRiskHeader}>
          <Text style={styles.headerText}>Risk Level</Text>
        </View>
        <View style={styles.colInterpHeader}>
          <Text style={styles.headerText}>Interpretation</Text>
        </View>
      </View>

      {/* ROW 1 */}
      <View wrap={false} style={[styles.row, { borderBottom: "1pt solid #000" }]}>
        <View style={styles.colScore}>
          <Text style={{ color: "#00A651", fontSize: 10 }}>≥ 85%</Text>
        </View>
        <View style={[styles.colRisk, { backgroundColor: "#00A651" }]}>
          <Text style={styles.darkText}>Low Risk</Text>
        </View>
        <View style={styles.colInterp}>
          <Text style={{ fontSize: 10 }}>Electrical systems and controls are well maintained, only minor improvements needed.</Text>
        </View>
      </View>

      {/* ROW 2 */}
      <View wrap={false} style={[styles.row, { borderBottom: "1pt solid #000" }]}>
        <View style={styles.colScore}>
          <Text style={{ color: "#FFFF00", fontSize: 10 }}>65% – 84%</Text>
        </View>
        <View style={[styles.colRisk, { backgroundColor: "#FFFF00" }]}>
          <Text style={styles.darkText}>Medium Risk</Text>
        </View>
        <View style={styles.colInterp}>
          <Text style={{ fontSize: 10 }}>Controls are adequate but with noticeable weaknesses.</Text>
        </View>
      </View>

      {/* ROW 3 */}
      <View wrap={false} style={[styles.row, { borderBottom: "1pt solid #000" }]}>
        <View style={styles.colScore}>
          <Text style={{ color: "#FFA500", fontSize: 10 }}>25% – 64%</Text>
        </View>
        <View style={[styles.colRisk, { backgroundColor: "#FFA500" }]}>
          <Text style={styles.darkText}>High Risk</Text>
        </View>
        <View style={styles.colInterp}>
          <Text style={{ fontSize: 10 }}>High vulnerabilities with major compliance gaps.</Text>
        </View>
      </View>

      {/* ROW 4 — NO BOTTOM BORDER */}
      <View wrap={false} style={styles.row}>
        <View style={styles.colScore}>
          <Text style={{ color: "#FF0000", fontSize: 10 }}>{"< "}25%</Text>
        </View>
        <View style={[styles.colRisk, { backgroundColor: "#FF0000" }]}>
          <Text style={styles.darkText}>Severe Risk</Text>
        </View>
        <View style={styles.colInterp}>
          <Text style={{ fontSize: 10 }}>Controls are ineffective, urgent corrective action required.</Text>
        </View>
      </View>

    </View>
  );


  const renderAuditDescriptionTable = () => {
    return (
      <View style={styles.tableForHistoryHSE}>
        {/* Header Row */}
        {/* <View style={styles.tableRow}>
        <Text style={styles.tableCellHeaderForHistory}>DESCRIPTION</Text>
        <Text style={styles.tableCellHeaderForHistory}>DETAILS</Text>
      </View> */}

        {/* Table rows */}
        <View style={styles.tableRow}>
          <Text style={[styles.tableCellForHistory, { backgroundColor: "#FFF8DC" }]}>Client</Text>
          <Text style={styles.tableCellForHistory}>{selectedOrganization?.label || "N/A"}</Text>
        </View>

        <View style={styles.tableRow}>
          <Text style={[styles.tableCellForHistory, { backgroundColor: "#FFF8DC" }]}>Location</Text>
          <Text style={styles.tableCellForHistory}>{selectedSite?.label || "N/A"}</Text>
        </View>

        <View style={styles.tableRow}>
          <Text style={[styles.tableCellForHistory, { backgroundColor: "#FFF8DC" }]}>Date of Site Visit</Text>
          <Text style={styles.tableCellForHistory}>
            {`${startDate.getDate()}-${(startDate.getMonth() + 1).toString().padStart(2, "0")}-${startDate.getFullYear()}`}
          </Text>
        </View>

        <View style={styles.tableRow}>
          <Text style={[styles.tableCellForHistory, { backgroundColor: "#FFF8DC" }]}>Study</Text>
          <Text style={styles.tableCellForHistory}>HSE Audit Report</Text>
        </View>
        {(timeFrom || timeTo) ?
          <View style={styles.tableRow}>
            <Text style={[styles.tableCellForHistory, { backgroundColor: "#FFF8DC" }]}>Time of Audit (From & To)</Text>
            <Text style={styles.tableCellForHistory}>
              {
                (timeFrom && timeTo
                  ? `${timeFrom} to ${timeTo}`
                  : timeFrom
                    ? `${timeFrom} to N/A`
                    : timeTo
                      ? `N/A to ${timeTo}`
                      : "N/A") + " (Date wise breakup)"}
            </Text>
          </View> : []}
        {briefPropertyDescription ?
          <View style={styles.tableRow}>
            <Text style={[styles.tableCellForHistory, { backgroundColor: "#FFF8DC" }]}>Brief Property Description</Text>
            <Text style={styles.tableCellForHistory}>{briefPropertyDescription || "N/A"}</Text>
          </View> : []}
        {numOfFloors ?
          <View style={styles.tableRow}>
            <Text style={[styles.tableCellForHistory, { backgroundColor: "#FFF8DC" }]}>Number of floors</Text>
            <Text style={styles.tableCellForHistory}>{numOfFloors || "N/A"}</Text>
          </View> : []}

        {avgStaffFootfall ?
          <View style={styles.tableRow}>
            <Text style={[styles.tableCellForHistory, { backgroundColor: "#FFF8DC" }]}>Average Staff Footfall</Text>
            <Text style={styles.tableCellForHistory}>{avgStaffFootfall || "N/A"}</Text>
          </View> : []}

        {noObjectionCertificate ?
          <View style={styles.tableRow}>
            <Text style={[styles.tableCellForHistory, { backgroundColor: "#FFF8DC" }]}>No Objection Certificate:</Text>
            <Text style={styles.tableCellForHistory}>{noObjectionCertificate || "N/A"}</Text>
          </View> : []}
        {nationalBuildingCodeCategory ?
          <View style={styles.tableRow}>
            <Text style={[styles.tableCellForHistory, { backgroundColor: "#FFF8DC" }]}>National Building Code Category</Text>
            <Text style={styles.tableCellForHistory}>{nationalBuildingCodeCategory || "N/A"}</Text>
          </View> : []}
        {coordinationgPersonClientside ?
          <View style={styles.tableRow}>
            <Text style={[styles.tableCellForHistory, { backgroundColor: "#FFF8DC" }]}>Coordinating Person – Client Side</Text>
            <Text style={styles.tableCellForHistory}>{coordinationgPersonClientside || "N/A"}</Text>
          </View> : []}
        {reportPreparedBy ?
          <View style={styles.tableRow}>
            <Text style={[styles.tableCellForHistory, { backgroundColor: "#FFF8DC" }]}>Report Prepared By</Text>
            <Text style={styles.tableCellForHistory}>{reportPreparedBy || "N/A"}</Text>
          </View> : []}
        {reportReviewedBy ?
          <View style={styles.tableRow}>
            <Text style={[styles.tableCellForHistory, { backgroundColor: "#FFF8DC" }]}>Report Reviewed By</Text>
            <Text style={styles.tableCellForHistory}>{reportReviewedBy || "N/A"}</Text>
          </View> : []}
        {buildingName ?
          <View style={styles.tableRow}>
            <Text style={[styles.tableCellForHistory, { backgroundColor: "#FFF8DC" }]}>Building Name</Text>
            <Text style={styles.tableCellForHistory}>{buildingName || "N/A"}</Text>
          </View> : []}

        <View style={styles.tableRow}>
          <Text style={[styles.tableCellForHistory, { backgroundColor: "#FFF8DC" }]}>Date of Submission of Report</Text>
          <Text style={styles.tableCellForHistory}>
            {`${endDate.getDate()}-${(endDate.getMonth() + 1).toString().padStart(2, "0")}-${endDate.getFullYear()}`}
          </Text>
        </View>
      </View>
    );
  };
  const renderReferencesTable = () => {
    return (
      <View style={styles.tableForHistoryHSE}>
        {/* Table Header */}
        <View style={styles.tableRow}>
          {/* <Text style={styles.tableCellHeaderForHistory}> */}
          <Text style={[styles.tableCellHeaderForHistoryReference, { flex: 1.2 }, { textAlign: "center" }]}>
            Reference Type and Document / Standard
          </Text>
          {/* <Text style={styles.tableCellHeaderForHistory}> */}
          <Text style={[styles.tableCellHeaderForHistoryReference, { flex: 1.8 }, { textAlign: "center" }]}>
            Relevance to Audit Findings
          </Text>
        </View>

        {/* Table Body */}
        {references?.map((ref) => {
          if (ref.type === "heading") {
            return (
              <View key={ref.id} style={styles.sectionHeadingRow}>
                <Text style={styles.sectionHeadingText}>{ref.section_name}</Text>
              </View>
            );
          } else {
            return (
              <View key={ref.id} style={styles.tableRow}>
                {/* <Text style={styles.tableCellForHistory}> */}
                <Text style={[styles.tableCellForHistory, { flex: 1.2 }]}>
                  {ref.document || "N/A"}</Text>
                {/* <Text style={styles.tableCellForHistory}> */}
                <Text style={[styles.tableCellForHistory, { flex: 1.8 }]}>
                  {ref.relevance || "N/A"}</Text>
              </View>
            );
          }
        })}
      </View>
    );
  };




  const renderFacilityInfoTable = (facilityInfo) => {
    return (
      <View>
        <View style={styles.tableForHistory}>
          {/* Row for headers */}
          <View style={styles.tableRow}>
            <Text style={styles.tableCellHeaderForHistory}>FACILITY INFORMATION</Text>
            <Text style={styles.tableCellHeaderForHistory}>COMMENTS & NOTES</Text>
          </View>

          {/* Rows for each item in facilityInfo */}
          {Object.entries(facilityInfo).map(([key, value], index) => (
            <View style={styles.tableRow} key={index}>
              <Text style={styles.tableCellForHistory}>{key}</Text>
              <Text style={styles.tableCellForHistory}>{value}</Text>
            </View>
          ))}
        </View>
      </View>
    );
  };

  return (
    <div>
      {/* Export PDF button */}
      {!pdfData && (
        <button
          onClick={generatePDF} // Call the generatePDF function on button click
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            background: isSaved ? "#efc71d" : "lightgrey",
            borderStyle: "none",
            borderRadius: "5px",
            fontWeight: "bold",
            padding: "11px 18px",
            textTransform: "uppercase",
            color: "white",
            fontSize: "1rem",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.5)"
          }}
          // className="button-styles"
          disabled={!isSaved || fethcingImages}
        >
          {generatingPDF || fethcingImages ? "Please Wait..." : "Generate PDF"}
          {pdfData ? null : (
            <FileDownloadIcon fontSize="small" style={{ marginLeft: "8px" }} />
          )}
        </button>
      )}

      {/* PDF download link */}
      {pdfData && (
        <PDFDownloadLink document={pdfData} fileName={ReportUID} style={{ textDecoration: "none" }}>
          {({ blob, url, loading, error }) => (
            <button
              style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                background: isSaved ? "#efc71d" : "lightgrey",
                borderStyle: "none",
                borderRadius: "5px",
                fontWeight: "bold",
                padding: "11px 18px",
                textTransform: "uppercase",
                color: "white",
                fontSize: "1rem",
                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.5)"
              }}
              disabled={!isSaved}
            >
              {loading ? "PLEASE WAIT..." : "EXPORT PDF"}
              {loading ? null : (
                <FileDownloadIcon
                  fontSize="small"
                  style={{ marginLeft: "8px" }}
                />
              )}
            </button>
          )}
        </PDFDownloadLink>
      )}
    </div>
  );
};

const styles = {
  body: {
    fontFamily: 'Montserrat',
  },
  // tableForHistory: {
  //   display: "table",
  //   width: "100%",
  //   borderStyle: "solid",
  //   borderWidth: 1,
  //   borderColor: "#000",
  //   marginTop: 10,
  // },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderColor: "#000",
  },
  tableCellHeaderForHistory: {
    flex: 1,
    fontWeight: "bold",
    fontSize: 10,
    padding: 5,
    backgroundColor: "#f0f0f0",
    borderRightWidth: 1,
    borderColor: "#000",
  },
  tableCellForHistory: {
    flex: 1,
    fontSize: 10,
    padding: 5,
    borderRightWidth: 1,
    borderColor: "#000",
  },
  sectionHeadingRow: {
    // backgroundColor: "#e0e0e0",
    backgroundColor: "#FFF7D7",
    borderBottomWidth: 1,
    // borderColor: "#000",
    padding: 5,
    borderStyle: "solid",
    borderColor: "black",
    borderWidth: 1,
  },
  sectionHeadingText: {
    fontWeight: "bold",
    fontSize: 10,
  },

  // coverImage: {
  //   width: "100%",
  //   height: 778,
  //   position: "relative",
  // },
  coverImage: {
    width: "100%",   // stretch across page
    height: 840,     // match A4 portrait height (≈595 pt in React-PDF)
    position: "relative",
    objectFit: "cover", // ensures no white gaps, maintains ratio
  },
  coverImageHSE: {
    width: "100%",   // stretch across page
    height: 840,
    position: "relative",
    objectFit: "cover", // ensures no white gaps, maintains ratio
  },
  rect: {
    position: "absolute",
    bottom: 282,
    left: 100,
    width: "90%",
    textAlign: "left",
  },
  riskTable: {
    marginHorizontal: 40,
    marginTop: 20,
    border: "1pt solid black",
  },
  row: {
    flexDirection: "row",
    // borderBottom: "1pt solid #000",
  },

  /* HEADER CELLS */
  colScoreHeader: {
    width: "20%",
    backgroundColor: "#307260",
    borderRight: "1pt solid #000",
    padding: 4,            // Reduced from 6
  },
  colRiskHeader: {
    width: "20%",
    backgroundColor: "#307260",
    borderRight: "1pt solid #000",
    padding: 4,
  },
  colInterpHeader: {
    width: "60%",
    backgroundColor: "#307260",
    padding: 4,
  },

  headerText: {
    color: "#efc71d",
    fontSize: 12,
    fontWeight: "bold",
    textAlign: "center",
  },

  /* ROW CELLS */
  colScore: {
    width: "20%",
    padding: 4,            // Reduced from 6
    borderRight: "1pt solid #000",
    justifyContent: "center",
    textAlign: "center",
  },

  colRisk: {
    width: "20%",
    padding: 4,            // Reduced from 6
    borderRight: "1pt solid #000",
    justifyContent: "center",
    textAlign: "center",
  },

  colInterp: {
    width: "60%",
    padding: 4,            // Reduced from 6
  },

  darkText: {
    color: "#000",
    fontSize: 10,          // Reduced from 12
    textAlign: "center",
  },

  bodyText: {
    fontSize: 10,          // Use this for interpretation text if needed
  },
  riskTableRow: {
    flexDirection: "row",
    borderTop: "1pt solid black",
  },
  riskTableHeaderCell: {

    textAlign: "center",
    backgroundColor: "#307260",
    color: "#efc71d",
    fontSize: 12,
    fontWeight: "bold",
    padding: 6,
    borderRight: "1pt solid black",
  },
  riskTableCell: {
    textAlign: "center",
    fontSize: 12,
    padding: 4,
    borderRight: "1pt solid black",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  riskTableCellInter: {
    // textAlign: "center",
    fontSize: 12,
    padding: 4,
    borderRight: "1pt solid black",
  },
  rectForHse: {
    position: "absolute",
    bottom: 320,
    left: 98,
    width: "90%",
    textAlign: "left",
  },
  rectNew: {
    position: "absolute",
    bottom: 282,
    width: "90%",
    textAlign: "left",
    backgroundColor: "#efc71d",
    clipPath: "polygon(0% 0%, 100% 0%, 85% 100%, 0% 100%)",
    WebkitClipPath: "polygon(0% 0%, 100% 0%, 85% 100%, 0% 100%)",
  },
  valueTextNew: {
    fontSize: 13,
    color: "#307268",
    margin: 5,
    padding: 3,
    borderBottom: "1px solid #307268",
  },
  reportName: {
    fontSize: 25,
    color: "#f9f3d9",
    bottom: 50,
    left: 70
  },
  organizationName: {
    fontSize: 13,
    color: "white",
    margin: 5,
    padding: 3,
  },
  labelText: {
    fontSize: 13,
    color: "#efc71d",
    margin: 5,
    padding: 3,
  },
  valueText: {
    fontSize: 13,
    color: "white",
    margin: 5,
    padding: 3,
  },
  dateTimeText: {
    fontSize: 13,
    color: "white",
    margin: 5,
    padding: 3,
  },
  link: {
    fontSize: 13,
    color: "#007bff",
    margin: 8,
    padding: 3,
  },
  pageTitle: {
    fontSize: 12,
    // backgroundColor: "#02075d",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end", // Align items to the end
    color: "white",
    alignItems: "center",
    padding: 5,
    margin: "5px",
    flexWrap: "wrap", // Allow text to wrap
    minHeight: "50px", // Adjust minimum height as needed
    boxSizing: "border-box"
  },
  pageContent: { fontSize: 12, marginLeft: 50, marginRight: 50, fontFamily: 'Montserrat', },
  pageContentHeading: { fontSize: 12, marginLeft: 50, marginRight: 5, fontFamily: 'Montserrat', },
  pageContentHSE: { fontSize: 12, marginRight: 50, fontFamily: 'Montserrat', marginLeft: 8 },
  table: {
    display: "table",
    width: "100%",
    borderStyle: "solid",
    borderColor: "black",
    borderWidth: 1,
    padding: 10,
  },
  tableElectrical: {
    display: "table",
    width: "100%",
    borderStyle: "solid",
    borderColor: "black",
    //  borderWidth: 1,
    padding: 10,
  },
  tableHSE: {
    display: "table",
    width: "100%",
    borderStyle: "solid",
    borderColor: "black",
    padding: 10,
  },
  tableForHistory: {
    display: "table",
    width: "80%",
    // borderWidth: 1,
    padding: 10,
    left: 40
  },
  tableForHistoryHSE: {
    display: "table",
    width: "85%",
    // borderWidth: 1,
    padding: 10,
    left: 40,
    // right:40
  },
  tableRow: {
    flexDirection: "row",
  },
  tableCellHeaderForSrNoElectrical: {
    width: "5%",
    backgroundColor: "#307268",
    padding: 5,
    borderStyle: "solid",
    borderColor: "black",
    borderWidth: 1,
    fontSize: 10,
    fontWeight: "bold",
    color: "#efc71d",
    textAlign: "center"
  },
  tableCellHeaderForSrNoHSE: {
    width: "3%",
    backgroundColor: "#307268",
    padding: 4,
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderColor: "#000",
    color: "#efc71d",
    fontSize: 9,
    textAlign: "center",
  },
  tableCellHeaderForSrNo: {
    width: "10%",
    backgroundColor: "#307268",
    padding: 5,
    borderStyle: "solid",
    borderColor: "black",
    borderWidth: 1,
    fontSize: 10,
    fontWeight: "bold",
    color: "#efc71d",
    textAlign: "center"
  },
  tableCellHeaderElectrical: {
    width: "10%",
    backgroundColor: "#307268",
    padding: 5,
    borderStyle: "solid",
    borderColor: "black",
    borderWidth: 1,
    fontSize: 10,
    fontWeight: "bold",
    color: "#efc71d",
    textAlign: "center"
  },
  tableCellHeaderHSE: {
    // Base width for Area / Equipment / Category headers. 8% -> 10% after the
    // Check Point column was removed (its 12% was shared across these + the
    // Observation / Recommendation / Objective Evidence columns). Criticality,
    // Status and Legal Reference override this width inline, so they are
    // unaffected.
    width: "10%",
    backgroundColor: "#307268",
    padding: 4,
    borderRightWidth: 1,
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderColor: "#000",
    color: "#efc71d",
    fontSize: 9,
    textAlign: "center",
  },
  tableCellHeaderElectricalObs: {
    width: "25%",
    backgroundColor: "#307268",
    padding: 5,
    borderStyle: "solid",
    borderColor: "black",
    borderWidth: 1,
    fontSize: 10,
    fontWeight: "bold",
    color: "#efc71d",
    textAlign: "center"
  },
  tableCellHeaderHSEObs: {
    // Observation + Recommendation headers (both use this style). 12% -> 14%
    // after redistributing the removed Check Point column.
    width: "14%",
    backgroundColor: "#307268",
    padding: 4,
    borderRightWidth: 1,
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderColor: "#000",
    color: "#efc71d",
    fontSize: 9,
  },
  tableCellHeaderElectricalRec: {
    width: "30%",
    backgroundColor: "#307268",
    padding: 5,
    borderStyle: "solid",
    borderColor: "black",
    borderWidth: 1,
    fontSize: 10,
    fontWeight: "bold",
    color: "#efc71d",
    textAlign: "center"
  },
  tableCellHeaderHSERec: {
    width: "15%",
    backgroundColor: "#307268",
    padding: 5,
    borderStyle: "solid",
    borderColor: "black",
    borderRightWidth: 1,
    borderBottomWidth: 1,
    fontSize: 10,
    fontWeight: "bold",
    color: "#efc71d",
    textAlign: "center"
  },
  tableCellHeaderElectricalPhoto: {
    width: "15%",
    backgroundColor: "#307268",
    padding: 5,
    borderStyle: "solid",
    borderColor: "black",
    borderWidth: 1,
    fontSize: 10,
    fontWeight: "bold",
    color: "#efc71d",
    textAlign: "center"
  },
  tableCellHeaderHSEPhoto: {
    // Objective Evidence header. 12% -> 14% after redistributing the removed
    // Check Point column.
    width: "14%",
    backgroundColor: "#307268",
    padding: 4,
    borderRightWidth: 1,
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderColor: "#000",
    fontSize: 9,
    color: "#efc71d",
  },
  tableCellHeaderHSEScore: {
    width: "5%",
    backgroundColor: "#307268",
    padding: 4,
    borderRightWidth: 1,
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderColor: "#000",
    color: "#efc71d",
    fontSize: 9,
    textAlign: "center",
  },
  tableCellHeader: {
    width: "20%",
    backgroundColor: "#307268",
    padding: 5,
    borderStyle: "solid",
    borderColor: "black",
    borderWidth: 1,
    fontSize: 10,
    fontWeight: "bold",
    color: "#efc71d",
    textAlign: "center"
  },
  cellForSrNoElectrical: {
    width: "5%",
    padding: 5,
    borderWidth: 1,
    borderColor: "#000",
  },
  cellForSrNoHSE: {
    width: "3%",
    padding: 5,
    // No borderLeftWidth: the body row View owns the table's outer-left border
    // (it repeats on every page fragment). Adding it here too drew a double line
    // on the left edge. borderRight stays as the Sr.No / Area separator.
    borderRightWidth: 1,
    borderBottomWidth: 1,
    // borderWidth: 1,
    borderColor: "#000",
  },
  cellForSrNo: {
    width: "10%",
    padding: 5,
    borderStyle: "solid",
    borderColor: "black",
    borderWidth: 1,
    fontSize: 12,
    backgroundColor: "whitesmoke",
    textAlign: "center"
  },
  tableCell: {
    width: "20%",
    padding: 5,
    borderStyle: "solid",
    borderColor: "black",
    borderWidth: 1,
    fontSize: 10,
    backgroundColor: "whitesmoke",
  },
  tableCellElectrical: {
    width: "10%",
    padding: 5,
    borderWidth: 1,
    borderColor: "#000",
  },
  tableCellHSE: {
    // Base width for Area / Equipment / Category body cells (8% -> 10% after the
    // Check Point column was removed). Criticality / Status / Legal override
    // their width inline and are unaffected.
    width: "10%",
    padding: 4,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: "#000",
  },
  tableCellElectricalObs: {
    width: "25%",
    padding: 5,
    borderWidth: 1,
    borderColor: "#000",
    flexWrap: 'wrap',
  },
  tableCellHSEObs: {
    // Observation + Recommendation body cells (both use this style). 12% -> 14%
    // after redistributing the removed Check Point column.
    width: "14%",
    padding: 4,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: "#000",
  },
  tableCellHSELegal: {
    width: "8%",
    padding: 4,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: "#000",
  },

  tableCellHSEScore: {
    width: "5%",
    padding: 4,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: "#000",
    alignItems: "center",
    justifyContent: "center",
  },
  tableCellElectricalRec: {
    width: "30%",
    padding: 5,
    borderWidth: 1,
    borderColor: "#000",
    flexWrap: 'wrap',
  },
  tableCellHSERec: {
    width: "14%",
    padding: 5,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: "#000",
    flexWrap: 'wrap',
  },
  tableCellElectricalPhoto: {
    width: "15%",
    padding: 5,
    borderWidth: 1,
    borderColor: "#000",
  },

  tableCellHSEPhoto: {
    // Objective Evidence body cell (last column). 12% -> 14% after redistributing
    // the removed Check Point column.
    // No borderRightWidth: the body row View owns the table's outer-right border
    // (it repeats on every page fragment). Adding it here too drew a double line
    // on the right edge. The Score cell's borderRight supplies the separator on
    // this cell's left.
    width: "14%",
    padding: 4,
    borderBottomWidth: 1,
    borderColor: "#000",
  },
  tableCellHeaderForHistory: {
    width: "50%",
    backgroundColor: "#efc71d",
    padding: 5,
    borderStyle: "solid",
    borderColor: "black",
    borderWidth: 1,
    fontSize: 12,
    fontWeight: "bold",
  },
  tableCellHeaderForHistoryReference: {
    width: "50%",
    backgroundColor: "#1E6255",
    color: "white",
    padding: 5,
    borderStyle: "solid",
    borderColor: "black",
    borderWidth: 1,
    fontSize: 12,
    fontWeight: "bold",
  },
  tableCellForHistory: {
    width: "50%",
    padding: 5,
    borderStyle: "solid",
    borderColor: "black",
    borderWidth: 1,
    fontSize: 11,

  },
  tableCellImage: { width: "100%", height: 80 },
  page: {
    fontFamily: 'Montserrat',
    flexDirection: "column",
    borderBottom: 1,
    paddingBottom: 30,
    paddingTop: 30,
  },
  footer: {
    position: "absolute",
    top: "100%",
    left: 15,
    right: 10,
    // borderTop: 1, 
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 2,
    backgroundColor: "white",
    fontSize: "12px",
    borderTopWidth: 1,
    borderTopStyle: "solid",
    borderTopColor: "grey",
    color: "grey",
    textAlign: "center"
  },
  leftText: {
    fontSize: 10,
  },
  rightText: {
    fontSize: 10,
  },
  logoImage: {
    width: 100,
    height: 30,
  },
  heading: {
    fontFamily: "Montserrat",
    fontSize: 13,
    color: "#307268",
    fontWeight: 800,
    marginTop: 0,
  },
  reportTitle: {
    width: "80%",
    flexWrap: "wrap",
  },
  subHeading: {
    fontSize: 13,
    fontWeight: 'bold',
    marginVertical: 10,
    textAlign: 'left',
    color: '#307268',

  },
  // new cover page design css
  reportDetailsLink: {
    color: '#307268',
    padding: '3px',
    margin: '5px',
    fontSize: '13px',
    textDecoration: 'none',
  },
  reportDetails: {
    position: 'absolute',
    top: '40%',
    left: '0',
    width: '65%',
    backgroundColor: '#efc71d',
    padding: '10px',
    boxSizing: 'border-box',
  },
  reportDetailsText: {
    fontSize: '15px',
    color: '#307268',
    margin: '5px',
    padding: '3px',
    borderBottom: '1px solid #307268',
  },
  reportTitleText: {
    fontSize: '45px',
    color: '#f9f3d9',
    fontWeight: 'bold',
    lineHeight: 1,
  },
  reportTitleDiv: {
    position: 'absolute',
    bottom: '15%',
    left: '20%',
    fontSize: '45px',
    fontWeight: '600',
    // fontFamily: 'Montserrat',
    color: '#f9f3d9',
  },
  reportYear: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  particularTableContainer: {
    width: "80%",
    marginLeft: 50,
    borderWidth: 1,
    borderColor: "black",
    marginTop: "10px",
    marginBottom: "10px",
  },

  particularTableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderColor: "black"
  },

  particularTableHeaderCell: {
    width: "50%",
    borderRightWidth: 1,
    borderColor: "black",
    padding: 5,
    backgroundColor: "#efc71d",
    justifyContent: "center",
    alignItems: "center"
  },

  particularTableHeaderText: {
    fontSize: 12,
    fontWeight: "bold",
    textAlign: "center"
  },

  particularTableCell: {
    width: "50%",
    borderRightWidth: 1,
    borderColor: "black",
    padding: 5
  },
  particularTableCelllast: {
    width: "50%",
    borderRightWidth: 1,
    // borderColor: "black",
    padding: 5
  },
  particularTableCellText: {
    fontSize: 11
  },

  yearLine: {
    flexGrow: 1,
    height: 1,
    width: '70px',
    backgroundColor: '#f9f3d9',
    marginRight: 10,
  }

};


export default ExportSavedReportPDF;
